'use strict';

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var React = require('react');
var uuid = require('react-uuid');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _createClass = require('@babel/runtime/helpers/createClass');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var debounce = require('lodash.debounce');
var _extends = require('@babel/runtime/helpers/extends');
var VisibilitySensor = require('react-visibility-sensor');
var _typeof = require('@babel/runtime/helpers/typeof');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var uuid__default = /*#__PURE__*/_interopDefaultLegacy(uuid);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var debounce__default = /*#__PURE__*/_interopDefaultLegacy(debounce);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var VisibilitySensor__default = /*#__PURE__*/_interopDefaultLegacy(VisibilitySensor);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);

var EVENT_DM_ERROR = "dm_error";
var ApiUtils = /*#__PURE__*/_createClass__default["default"](function ApiUtils() {
  _classCallCheck__default["default"](this, ApiUtils);
});
_defineProperty__default["default"](ApiUtils, "server", null);
_defineProperty__default["default"](ApiUtils, "accessToken", null);
_defineProperty__default["default"](ApiUtils, "dealerAccessKey", null);
_defineProperty__default["default"](ApiUtils, "clientId", null);
_defineProperty__default["default"](ApiUtils, "config", null);
_defineProperty__default["default"](ApiUtils, "events", []);
_defineProperty__default["default"](ApiUtils, "eventToken", null);
_defineProperty__default["default"](ApiUtils, "defaultHeaders", function () {
  return {
    "Authorization": "Bearer " + ApiUtils.accessToken,
    "Accept": 'application/json',
    "X-DM-Access-Key": ApiUtils.dealerAccessKey,
    "X-Api-Key": ApiUtils.clientId
  };
});
_defineProperty__default["default"](ApiUtils, "getRequest", function (urlStr, params, config) {
  var url = ApiUtils.server + urlStr;
  if (urlStr.indexOf("?") < 0) url += "?";
  if (params) {
    Object.keys(params).forEach(function (key) {
      if (params[key] != null && params[key] != undefined) {
        url += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
      }
    });
  }
  if (ApiUtils.getVisitorId()) url += "&vid=" + ApiUtils.getVisitorId();
  return fetch(url, {
    method: 'GET',
    headers: ApiUtils.defaultHeaders()
  }).then(function (response) {
    if (response.ok || response.status == 401) {
      return response.status == 204 ? {} : response.json();
    } else {
      response.json().then(function (data) {
        window.dispatchEvent(new CustomEvent(EVENT_DM_ERROR, {
          detail: data
        }));
      });
      return null;
    }
  })["catch"](function (error) {
    ApiUtils.logError(error);
    throw error;
  });
});
_defineProperty__default["default"](ApiUtils, "postRequest", function (urlStr, data, method, config) {
  var contentType = 'application/json';
  if (ApiUtils.getVisitorId()) {
    data['vid'] = ApiUtils.getVisitorId();
  }
  var headers = ApiUtils.defaultHeaders();
  headers['Content-Type'] = contentType;
  if (config && config.headers) {
    Object.keys(config.headers).forEach(function (key) {
      headers[key] = config.headers[key];
    });
  }
  if (config) {
    headers['X-DM-Access-Key'] = config.access_key;
  }
  var url = ApiUtils.server + urlStr;
  var jsonBody = data;
  return fetch(url, {
    method: method || 'POST',
    headers: headers,
    body: JSON.stringify(jsonBody)
  }).then(function (response) {
    if (response.ok) {
      return response.status == 204 ? {} : response.json();
    } else {
      response.json().then(function (data) {
        window.dispatchEvent(new CustomEvent(EVENT_DM_ERROR, {
          detail: data
        }));
      });
      return null;
    }
  })["catch"](function (error) {
    ApiUtils.logError(error);
    throw error;
  });
});
_defineProperty__default["default"](ApiUtils, "logEvent", function (event) {
  ApiUtils.events.push(event);
  setTimeout(function () {
    if (ApiUtils.config && ApiUtils.events.length > 0) {
      var array = _toConsumableArray__default["default"](ApiUtils.events);
      array.map(function (e) {
        e.did = ApiUtils.config.id;
        e.ip = ApiUtils.config.ip_address;
      });
      ApiUtils.events = [];
      ApiUtils.postRequest("/v1/events", {
        events: array
      });
    }
  }, 5000);
});
_defineProperty__default["default"](ApiUtils, "getVisitorId", function () {
  if (typeof localStorage !== 'undefined' && localStorage.getItem("_dm_vid")) return localStorage.getItem("_dm_vid");
  return null;
});
_defineProperty__default["default"](ApiUtils, "logError", function (error) {});

// External
var DM_ERROR = EVENT_DM_ERROR;
var DM_LOG_EVENT = "dm_log_event";
var DM_FORM_ERROR = "dm_form_error";
var DM_EVENT_VISITOR_IDS = "dm_visitor_ids";
var DM_EVENT_CONFIG = "dm_config";
var DM_EVENT_DR_DEAL_LOADED = "dr_deal_loaded";
var DM_EVENT_DR_OFFERS_LOADED = "dr_offers_loaded";
var DM_EVENT_DR_PLANS_LOADED = "dr_plans_loaded";
var DM_EVENT_TRADE_ESTIMATE = "dm_trade_estimate";
var DM_EVENT_SOFT_CREDIT_RESULTS = "dm_soft_credit_results";
var DM_EVENT_CREDIT_APP_RESULTS = "dm_credit_app_results";
var DM_EVENT_APPOINTMENT_RESULTS = "dm_appointment_results";
var DM_EVENT_FILE_SELECT = "dm_file_select";
var DM_TRADE_STEP_MILES = "miles";
var DM_TRADE_STEP_OPTIONS = "options";

// Internal
var DM_EVENT_CONFIG_LOADED = "dm_config_loaded";
var DM_EVENT_DR_DEAL_PARAM_INPUT = "dr_deal_param_input";
var DM_EVENT_DR_DEAL_TYPE_CHANGE = "dr_deal_type_change";
var DM_EVENT_DR_DEAL_TYPE_REQUEST = "dr_deal_type_req";
var DM_EVENT_DR_DEAL_TYPE_SYNC = "dr_deal_type_sync";
var DM_EVENT_DR_DEAL_TERMS = "dr_deal_terms";
var DM_EVENT_DR_DEAL_PARAM_CHANGE = "dr_deal_param_change";
var DM_EVENT_DR_DEAL_REQUEST = "dr_deal_requoest";
var DM_EVENT_DR_DEAL_SYNC = "dr_deal_sync";
var DM_EVENT_DR_DEAL_DETAILS_LOADED = "dr_deal_details_loaded";
var DM_EVENT_DR_OFFER_CHANGE = "dr_offer_change";
var DM_EVENT_DR_OFFER_TOGGLE = "dr_offer_toggle";
var DM_EVENT_DR_OFFERS_SYNC = "dr_offers_sync";
var DM_EVENT_DR_OFFERS_DATA = "dr_offers_data";
var DM_EVENT_DR_PLAN_CHANGE = "dr_plan_change";
var DM_EVENT_DR_PLAN_TOGGLE = "dr_plan_toggle";
var DM_EVENT_DR_PLAN_SYNC = "dr_plan_sync";
var DM_EVENT_DR_DEAL_TERMS_REFRESH = "dr_deal_terms_refresh";
var DM_EVENT_DR_UPDATE_TRADE = "dr_trade_update";
var DM_EVENT_TRADE_CONFIG_REFRESH = "trade_config_refresh";
var DM_EVENT_FIELD_OPTIONS = "field_options";
var DM_EVENT_FIELD_VALUE_UPDATE = "dm_field_value_update";
var DM_EVENT_TRADE_FORM_SUBMIT = "trade_form_submit";
var DM_EVENT_TRADE_VEHICLE_INPUT = "trade_vehicle_input";
var DM_EVENT_TRADE_VEHICLE_SUBMIT = "trade_vehicle_submit";
var DM_EVENT_TRADE_VEHICLE_UPDATE = "trade_vehicle_update";
var DM_EVENT_TRADE_APPLY_DEAL = "trade_apply_to_deal";
var DM_EVENT_TRADE_REMOVE_DEAL = "trade_remove_from_deal";
var DM_EVENT_SOFT_CREDIT_INPUT = "soft_credit_input";
var DM_EVENT_CREDIT_APP_INPUT = "credit_app_input";
var DM_EVENT_CREDIT_APP_SUBMIT = "credit_app_submit";
var DM_EVENT_MESSAGING_INPUT = "messaging_input";
var DM_EVENT_CONTACT_INPUT = "contact_input";
var DM_EVENT_APPOINTMENT_INPUT = "appointment_input";
function useDMEventListener(event, listener) {
  React.useEffect(function () {
    var t = window;
    // const eventName = event + (event != DM_EVENT_CONFIG_LOADED ? "_" + ApiUtils.eventToken : "")
    var eventName = event;
    t.addEventListener(eventName, listener);
    return function () {
      return t ? t.removeEventListener(event, listener) : null;
    };
  });
}

function useVisitorId() {
  if (localStorage && localStorage.getItem("_dm_vid")) return localStorage.getItem("_dm_vid");
}
function useVisitorSessionId() {
  if (localStorage && localStorage.getItem("_dm_vid")) return localStorage.getItem("_dm_vid");
}
function emitDMEvent(name, data) {
  // const eventName = name + (name != DM_EVENT_CONFIG_LOADED ? "_" + ApiUtils.eventToken : "")
  var eventName = name;
  window.dispatchEvent(new CustomEvent(eventName, {
    detail: data
  }));
}
function gtag() {
  dataLayer.push(arguments);
}
function logGAEvent(eventName, params) {
  try {
    gtag('event', eventName, params);
  } catch (e) {}
}
function logEvent$1(en, et, c, data, props) {
  props = Object.assign({}, ApiUtils.config, props);
  try {
    var _props, _props2, _props3;
    var payload = {
      "vid": props.visitorId || useVisitorId(),
      "en": en,
      "et": et,
      "c": c,
      "sid": useVisitorSessionId() || useVisitorId(),
      "es": ((_props = props) === null || _props === void 0 ? void 0 : _props.source) || document.location.href,
      "at": new Date().getTime(),
      "d": data,
      "tm": (_props2 = props) === null || _props2 === void 0 ? void 0 : _props2.test_mode,
      "tv": (_props3 = props) === null || _props3 === void 0 ? void 0 : _props3.test_value,
      "s": props.site,
      "v": props.version
    };
    var car = props.car || (ApiUtils.config ? ApiUtils.config.car : null);
    if (car) {
      payload.vin = car.vin;
      payload.vy = car.year;
      payload.vk = car.make_name;
      payload.vm = car.model_name;
      payload.vt = car.trim_name;
      payload.vp = car.msrp || car.price;
    }
    ApiUtils.logEvent(payload);
    emitDMEvent("log_event_ext", payload);
  } catch (e) {
    // log error
  }
}
function logFormSubmitEvent(form) {
  logGAEvent("form_submit", {
    form_id: form.id,
    form_name: form.name,
    form_destination: form.action,
    form_length: 1
  });
}
function logFieldChangeEvent(field) {
  var form = field === null || field === void 0 ? void 0 : field.form;
  logGAEvent("field_change", {
    field_id: field === null || field === void 0 ? void 0 : field.id,
    field_name: field === null || field === void 0 ? void 0 : field.name,
    form_id: form === null || form === void 0 ? void 0 : form.id,
    form_name: form === null || form === void 0 ? void 0 : form.name
  });
}
function onDMDealTypeChange(type) {
  emitDMEvent(DM_EVENT_DR_DEAL_TYPE_CHANGE, {
    type: type
  });
}
function onDMTradeVehicleSubmit(type) {
  emitDMEvent(DM_EVENT_TRADE_VEHICLE_SUBMIT, {
    type: type
  });
}
function saveQuoteIdForSession(vin, quote_id) {
  if (localStorage) localStorage.setItem("_dm_qid_" + vin, quote_id);
}
function getQuoteIdForSession(vin) {
  if (localStorage) return localStorage.getItem("_dm_qid_" + vin);
  return null;
}

function GA4(props) {
  useDMEventListener("log_event_ext", function (event) {
    var data = event.detail;
    var key = data.en + "_" + data.et + (data.c ? "_" + data.c : "");
    logGAEvent(key, data);
  });
  React.useEffect(function () {
    load(props.id);
  }, []);
  var load = function load(dtmId) {
    var script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=" + dtmId;
    script.async = true;
    script.onload = initGTM(dtmId);
    document.body.appendChild(script);
  };
  var initGTM = function initGTM(dtmId) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', dtmId, {
      'debug_mode': true
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
}

function ShiftDigitalTagging(props) {
  var EVENT_MAPPING = {
    'page_view': 'drInitialClick',
    'dr_load_calc': 'drPaymentCalcShown',
    'trade_edit_vehicle_plate': 'drTradeInStart',
    'vdp_scroll_plans': 'drFiShown'

    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drApptSchedShown',
    // 'not_mapped' : 'drApptSchedStart',
    // 'not_mapped' : 'drApptSchedFinish',
    // 'not_mapped' : 'drTradeInShown',
    // 'not_mapped' : 'drTradeInStart',
    // 'not_mapped' : 'drTradeInFinish',
    // 'not_mapped' : 'drPreQFinish',
    // 'not_mapped' : 'drOutOfStockFormStart',
    // 'not_mapped' : 'drCreditAppFinish',
    // 'not_mapped' : 'drImpression',
    // 'not_mapped' : 'drInitialClick',
    // 'not_mapped' : 'drTradeInShown',
    // 'not_mapped' : 'drTradeInStart',
    // 'not_mapped' : 'drTradeInFinish',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcInteraction',
    // 'not_mapped' : 'drPaymentCalcFinish',
    // 'not_mapped' : 'drLeadFormShown',
    // 'not_mapped' : 'drLeadFormShown',
    // 'not_mapped' : 'drLeadFormShown',
    // 'not_mapped' : 'drLeadFormShown',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormStart',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drLeadFormFinish',
    // 'not_mapped' : 'drApptSchedShown',
    // 'not_mapped' : 'drApptSchedStart',
    // 'not_mapped' : 'drApptSchedFinish',
    // 'not_mapped' : 'drPreQShown',
    // 'not_mapped' : 'drPreQStart',
    // 'not_mapped' : 'drPreQFinish',
    // 'not_mapped' : 'drCreditAppShown',
    // 'not_mapped' : 'drCreditAppStart',
    // 'not_mapped' : 'drCreditAppFinish',
    // 'not_mapped' : 'drFiShown',
    // 'not_mapped' : 'drFiFinish',
    // 'not_mapped' : 'drAddToCart',
    // 'not_mapped' : 'drAddToCart',
    // 'not_mapped' : 'drAccessoriesShown',
    // 'not_mapped' : 'drAccessoriesFinish',
    // 'not_mapped' : 'drDropSave',
    // 'not_mapped' : 'drContractShown',
    // 'not_mapped' : 'drContractStart',
    // 'not_mapped' : 'drContractFinish',
    // 'not_mapped' : 'drOfferAdded',
  };

  useDMEventListener("log_event_ext", function (event) {
    var data = event.detail;
    var key = data.en + "_" + data.et + (data.c ? "_" + data.c : "");
    var eventMapping = EVENT_MAPPING[key];
    if (eventMapping && props.car) {
      if (window['sd']) {
        var car = props.car;
        window['sd']('dataLayer', {
          digRet: {
            priceUnlocked: 'False',
            dealId: data.vid,
            provider: 'DR Provider',
            vehicleYear: '' + car.year,
            vehicleMake: car.make_name,
            vehicleModel: car.model_name,
            vehicleVin: car.vin,
            vehicleStatus: 'New'
          },
          events: eventMapping
        });
        window['sd']('send');
      }
    }
  });
  React.useEffect(function () {
    var shiftTagging = props.config;
    if (shiftTagging && typeof sd == "undefined") {
      setup(window, document, 'script', shiftTagging.api_url, 'sd');
      sd('create', shiftTagging.client_id, shiftTagging.dealer_id, shiftTagging.app);
    }
  }, []);
  var setup = function setup(i, s, o, g, r, a, m) {
    i['ShiftAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
}

function PixallAnalytics(props) {
  var config = {
    "dr_load_calc": {
      event: "ajaxPageView",
      feature: "Digital_Retailing",
      pageType: 'vdp',
      label: 'Digital Retailing - Calculation'
    },
    'trade_edit_vehicle_plate': {
      event: "submit",
      feature: "Digital_Retailing",
      pageType: 'vdp',
      label: 'Trade - Vehicle Lookup'
    },
    'vdp_scroll_plans': {
      event: "ajaxPageView",
      feature: "Digital_Retailing",
      pageType: 'vdp',
      label: 'Digital Retailing - F&I Products'
    }
  };
  useDMEventListener("log_event_ext", function (event) {
    var data = event.detail;
    send(data);
  });
  React.useEffect(function () {
    var script = document.createElement('script');
    script.async = true;
    document.body.appendChild(script);
    script.onload = initPixall();
    script.src = props.config.api_url;
  }, []);
  var initPixall = function initPixall() {
    setTimeout(function () {
      if (typeof _pxam !== "undefined") {
        _pxam.push({
          type: 'meta-data',
          pageType: 'home',
          pageId: 'homepage'
        });
      }
    }, 1000);
    initializePixallScript();
  };
  var send = function send(data) {
    var key = data.en + "_" + data.et + (data.c ? "_" + data.c : "");
    var type = config[key];
    if (!type) return;
    var pxEventFields = {
      type: 'event',
      label: type.label,
      feature: type.feature,
      pageType: type.pageType
    };
    if (data.et == 'change') pxEventFields.formEventId = guid();
    var pxData = {
      pxamMessageType: 'pxamContentEvent',
      eventType: type.event,
      eventFields: pxEventFields,
      eventSource: props.src
    };
    window.postMessage(JSON.stringify(pxData), document.location.origin);
  };
  var initializePixallScript = function initializePixallScript() {
    if (typeof window.Pixall != "undefined") {
      // set variables
      new window.Pixall().init({
        dealerCode: props.config.dealer_id,
        wspCode: props.config.client_id,
        pageType: 'other',
        program: 'DealerDotCom',
        domainOverride: false,
        feature: props.config.ref_id || props.config.client_id,
        label: props.config.app || props.config.client_id
      });
    }
  };
  var s4 = function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  };
  var guid = function guid() {
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };
}

function AdobeAnalytics(props) {
  var config = {
    "dr_load_calc": {
      eventName: "load",
      eventAction: "quote",
      formDescription: 'vdpQuote',
      formType: 'finance'
    },
    'trade_edit_vehicle_plate': {
      eventName: "submit",
      eventAction: "trade",
      formDescription: 'tradeVehcile',
      formType: 'trade'
    },
    'vdp_scroll_plans': {
      eventName: "view",
      eventAction: "products",
      formDescription: 'vdpProducts',
      formType: 'products'
    }
  };
  useDMEventListener("log_event_ext", function (event) {
    var data = event.detail;
    send(data);
  });
  React.useEffect(function () {}, []);
  var send = function send(data) {
    var key = data.en + "_" + data.et + (data.c ? "_" + data.c : "");
    var eventData = config[key];
    if (!eventData) return;
    sendDigitalDataEvent({
      type: "CustomTagEvent",
      eventName: eventData.eventName,
      eventAction: eventData.eventAction,
      attributes: {
        formDescription: eventData.formDescription,
        formType: eventData.formType,
        displayType: "in-page",
        displayFormat: "inPage"
      }
    });
  };
  var sendDigitalDataEvent = function sendDigitalDataEvent(eventData) {
    if (typeof window.digitalData !== 'undefined') {
      window.digitalData.newEvent(eventData);
    }
  };
}

// sendDigitalDataEvent({
//   type: "CustomTagEvent",
//   eventName: "start",
//   eventAction: "form", 
//   attributes: { 
//       formDescription: "lead", 
//       formType: "vendor tradein tool", 
//       displayType: eventData.log.iframe ? "iframe" : "in-page", /* (The values for displayType are limited to: "modal", "in-page", "iframe") */
//       displayFormat: "inPage", /* (The values for displayFormat are limited to: "modal", "newPageLoad", "inPage", and "navigation".) */
//       tradeInProvider: eventData.log.tradein_widget
//   }
// }, eventData.log);

// sendDigitalDataEvent({
//   type: "CustomTagEvent",
//   eventName: "start",
//   eventAction: "form",
//   attributes: {
//       formDescription: "lead",
//       formType: "finance",
//       displayType: "inPage",
//       displayFormat: "iframe",
//       financeProvider: "700Credit" /* ([Finance Provider Name]) */
//   }
// }, eventData.log);

// sendDigitalDataEvent({
//   type: "CustomTagEvent", 
//   eventName: "submit",
//   eventAction: "form", 
//   attributes: {
//       formDescription: "lead", 
//       formType: "vendor tradein tool", 
//       leadId: leadId, /* ([Unique Lead ID that is passed to IB or can be joined with data sent to IB to identify the lead]: chat session id) */
//       displayType: eventData.log.iframe ? "iframe" : "in-page", /* (The values for displayType are limited to: "modal", "in-page", "iframe".) */
//       displayFormat: "inPage", /* (The values for displayFormat are limited to: "modal", "newPageLoad", "inPage", and "navigation".) */
//       tradeInProvider: eventData.log.tradein_widget, /* ([Trade in Tool Provider Name]) */
//       tradeInVehicleYear: tradeData.tradeInVehicleYear, /* ([Year of the Trade-In Vehicle]) */
//       tradeInVehicleMake: tradeData.tradeInVehicleMake, /* ([Make of the Trade-In Vehicle]) */
//       tradeInVehicleModel: tradeData.tradeInVehicleModel, /* ([Model of the Trade-In Vehicle]) */
//       desiredVehicleYear: desiredVehicle.year, /* ([The year of the vehicle the car shopper is interested in purchasing or leasing]) */
//       desiredVehicleMake: desiredVehicle.make, /* ([Make of the vehicle the car shopper is interested in purchasing or leasing]) */
//       desiredVehicleModel: desiredVehicle.model /* ([Model of the vehicle the car shopper is interested in purchasing or leasing]) */
//   }

var DR_DEAL_TYPE = "dr_deal_type";
var DR_CASH_DOWN = "dr_down_payment";
var DR_CREDIT_TIER = "dr_credit_tier";
var DR_FINANCE_TERM = "dr_finance_term";
var DR_LEASE_MILES = "dr_lease_miles";
var DR_LEASE_TERM = "dr_lease_term";
var DR_TRADE_VALUE = "dr_trade_estimate";
var DR_TRADE_PAYOFF = "dr_trade_payoff";
var DR_OFFER = "dro_offer";
var DR_PLAN = "drp_protection_plan";
var CREDIT_APP_FIRST_NAME = "ca_first_name";
var CREDIT_APP_MIDDLE_NAME = "ca_middle_name";
var CREDIT_APP_LAST_NAME = "ca_last_name";
var CREDIT_APP_SUFFIX = "ca_suffix";
var CREDIT_APP_EMAIL = "ca_email";
var CREDIT_APP_PHONE = "ca_phone";
var CREDIT_APP_MOBILE_PHONE = "ca_mobile_phone";
var CREDIT_APP_ADDRESS = "ca_address";
var CREDIT_APP_ADDRESS_2 = "ca_address_2";
var CREDIT_APP_CITY = "ca_city";
var CREDIT_APP_STATE = "ca_state";
var CREDIT_APP_ZIP = "ca_zip";
var CREDIT_APP_SSN = "ca_ssn";
var CREDIT_APP_DOB = "ca_dob";
var CREDIT_APP_ADDR_LESS_2Y = "ca_curr_addr_less_2y";
var CREDIT_APP_PREV_ADDR_ADDRESS = "ca_prev_addr_address";
var CREDIT_APP_PREV_ADDR_CITY = "ca_prev_addr_city";
var CREDIT_APP_PREV_ADDR_STATE = "ca_prev_addr_state";
var CREDIT_APP_PREV_ADDR_ZIP = "ca_prev_addr_zip";
var CREDIT_APP_HOUSING_STATUS = "ca_housing_status";
var CREDIT_APP_MORTGAGE_RENT = "ca_mortgage_rent";
var CREDIT_APP_TIME_AT_ADDR_YEARS = "ca_time_at_addr_years";
var CREDIT_APP_TIME_AT_ADDR_MONTHS = "ca_time_at_addr_months";
var CREDIT_APP_INCOME_TYPE = "ca_income_type";
var CREDIT_APP_INCOME_INTERVAL = "ca_income_interval";
var CREDIT_APP_INCOME = "ca_income";
var CREDIT_APP_OTHER_INCOME_TYPE = "ca_income_other_type";
var CREDIT_APP_OTHER_INCOME_INTERVAL = "ca_income_other_interval";
var CREDIT_APP_OTHER_INCOME = "ca_income_other";
var CREDIT_APP_OTHER_INCOME_SOURCE = "ca_income_other_source";
var CREDIT_APP_EMPLOYMENT_STATUS = "ca_employment_status";
var CREDIT_APP_EMPLOYER = "ca_employer";
var CREDIT_APP_JOB_TITLE = "ca_job_title";
var CREDIT_APP_WORK_PHONE = "ca_work_phone";
var CREDIT_APP_TIME_AT_JOB_YEARS = "ca_time_at_job_years";
var CREDIT_APP_TIME_AT_JOB_MONTHS = "ca_time_at_job_months";
var CREDIT_APP_PREV_EMPLOYMENT_STATUS = "ca_prev_employment_status";
var CREDIT_APP_PREV_EMPLOYER = "ca_prev_employer";
var CREDIT_APP_PREV_JOB_TITLE = "ca_prev_job_title";
var CREDIT_APP_PREV_WORK_PHONE = "ca_prev_work_phone";
var CREDIT_APP_PREV_TIME_AT_JOB_YEARS = "ca_prev_time_at_job_years";
var CREDIT_APP_PREV_TIME_AT_JOB_MONTHS = "ca_prev_time_at_job_months";
var CREDIT_APP_HAVE_CO_APP = "ca_curr_co_app";
var CREDIT_APP_CO_APP_FIRST_NAME = "ca_co_app_first_name";
var CREDIT_APP_CO_APP_MIDDLE_NAME = "ca_co_app_middle_name";
var CREDIT_APP_CO_APP_LAST_NAME = "ca_co_app_last_name";
var CREDIT_APP_CO_APP_SUFFIX = "ca_co_app_suffix";
var CREDIT_APP_CO_APP_EMAIL = "ca_co_app_email";
var CREDIT_APP_CO_APP_PHONE = "ca_co_app_phone";
var CREDIT_APP_CO_APP_MOBILE_PHONE = "ca_co_app_mobile_phone";
var CREDIT_APP_CO_APP_ADDRESS = "ca_co_app_address";
var CREDIT_APP_CO_APP_ADDRESS_2 = "ca_co_app_address_2";
var CREDIT_APP_CO_APP_CITY = "ca_co_app_city";
var CREDIT_APP_CO_APP_STATE = "ca_co_app_state";
var CREDIT_APP_CO_APP_ZIP = "ca_co_app_zip";
var CREDIT_APP_CO_APP_SSN = "ca_co_app_ssn";
var CREDIT_APP_CO_APP_DOB = "ca_co_app_dob";
var CREDIT_APP_CO_APP_ADDR_LESS_2Y = "ca_co_app_curr_addr_less_2y";
var CREDIT_APP_CO_APP_PREV_ADDR_ADDRESS = "ca_co_app_prev_addr_address";
var CREDIT_APP_CO_APP_PREV_ADDR_CITY = "ca_co_app_prev_addr_city";
var CREDIT_APP_CO_APP_PREV_ADDR_STATE = "ca_co_app_prev_addr_state";
var CREDIT_APP_CO_APP_PREV_ADDR_ZIP = "ca_co_app_prev_addr_zip";
var CREDIT_APP_CO_APP_HOUSING_STATUS = "ca_co_app_housing_status";
var CREDIT_APP_CO_APP_MORTGAGE_RENT = "ca_co_app_mortgage_rent";
var CREDIT_APP_CO_APP_TIME_AT_ADDR_YEARS = "ca_co_app_time_at_addr_years";
var CREDIT_APP_CO_APP_TIME_AT_ADDR_MONTHS = "ca_co_app_time_at_addr_months";
var CREDIT_APP_CO_APP_INCOME_TYPE = "ca_co_app_income_type";
var CREDIT_APP_CO_APP_INCOME_INTERVAL = "ca_co_app_income_interval";
var CREDIT_APP_CO_APP_INCOME = "ca_co_app_income";
var CREDIT_APP_CO_APP_OTHER_INCOME_TYPE = "ca_co_app_income_other_type";
var CREDIT_APP_CO_APP_OTHER_INCOME_INTERVAL = "ca_co_app_income_other_interval";
var CREDIT_APP_CO_APP_OTHER_INCOME = "ca_co_app_income_other";
var CREDIT_APP_CO_APP_OTHER_INCOME_SOURCE = "ca_co_app_income_other_source";
var CREDIT_APP_CO_APP_EMPLOYMENT_STATUS = "ca_co_app_employment_status";
var CREDIT_APP_CO_APP_EMPLOYER = "ca_co_app_employer";
var CREDIT_APP_CO_APP_JOB_TITLE = "ca_co_app_job_title";
var CREDIT_APP_CO_APP_WORK_PHONE = "ca_co_app_work_phone";
var CREDIT_APP_CO_APP_TIME_AT_JOB_YEARS = "ca_co_app_time_at_job_years";
var CREDIT_APP_CO_APP_TIME_AT_JOB_MONTHS = "ca_co_app_time_at_job_months";
var CREDIT_APP_CO_APP_PREV_EMPLOYMENT_STATUS = "ca_co_app_prev_employment_status";
var CREDIT_APP_CO_APP_PREV_EMPLOYER = "ca_co_app_prev_employer";
var CREDIT_APP_CO_APP_PREV_JOB_TITLE = "ca_co_app_prev_job_title";
var CREDIT_APP_CO_APP_PREV_WORK_PHONE = "ca_co_app_prev_work_phone";
var CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_YEARS = "ca_co_app_prev_time_at_job_years";
var CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_MONTHS = "ca_co_app_prev_time_at_job_months";
var TRADE_VEHICLE_ID_TYPE = "trv_vehicle_id_type";
var TRADE_VEHICLE_PLATE = "trv_vehicle_plate";
var TRADE_VEHICLE_STATE = "trv_vehicle_state";
var TRADE_VEHICLE_VIN = "trv_vehicle_vin";
var TRADE_VEHICLE_MILES = "trv_vehicle_miles";
var TRADE_VEHICLE_ZIP = "trv_vehicle_zip";
var TRADE_VEHICLE_CONDITION = "trv_vehicle_condition";
var TRADE_VEHICLE_OPTION = "trv_vehicle_option";
var TRADE_VEHICLE_PAYOFF = "trv_vehicle_payoff";
var SOFT_CREDIT_FIRST_NAME = "scf_first_name";
var SOFT_CREDIT_LAST_NAME = "scf_last_name";
var SOFT_CREDIT_EMAIL = "scf_email";
var SOFT_CREDIT_PHONE = "scf_home_phone";
var SOFT_CREDIT_ADDRESS = "scf_address";
var SOFT_CREDIT_CITY = "scf_city";
var SOFT_CREDIT_STATE = "scf_state";
var SOFT_CREDIT_ZIP = "scf_zip";
var CONTACT_FIRST_NAME = "c_first_name";
var CONTACT_LAST_NAME = "c_last_name";
var CONTACT_EMAIL = "c_email";
var CONTACT_PHONE = "c_phone";
var CONTACT_MOBILE_PHONE = "c_mobile_phone";
var CONTACT_ZIP = "c_zip";
var APPOINTMENT_FIRST_NAME = "appo_first_name";
var APPOINTMENT_LAST_NAME = "appo_last_name";
var APPOINTMENT_EMAIL = "appo_email";
var APPOINTMENT_PHONE = "appo_phone";
var APPOINTMENT_DATE = "appo_appointment_date";
var APPOINTMENT_TIME = "appo_appointment_time";
var APPOINTMENT_DATETIME = "appo_appointment_datetime";
var APPOINTMENT_OPTIONS = "appo_options";
var APPOINTMENT_VEHICLE_VIN = "appo_vehicle_vin";
var APPOINTMENT_VEHICLE_YEAR = "appo_vehicle_year";
var APPOINTMENT_VEHICLE_MAKE = "appo_vehicle_make";
var APPOINTMENT_VEHICLE_MODEL = "appo_vehicle_model";
var DOCUMENT = "up_document";
var MESSAGING_BODY = "msg_message_body";
var US_STATES = ["", "AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"];

// Mapping of field prefix to form events
var FIELD_EVENT = {
  "dr": DM_EVENT_DR_DEAL_PARAM_INPUT,
  "dro": DM_EVENT_DR_OFFER_CHANGE,
  "drp": DM_EVENT_DR_PLAN_CHANGE,
  "ca": DM_EVENT_CREDIT_APP_INPUT,
  "trv": DM_EVENT_TRADE_VEHICLE_INPUT,
  "scf": DM_EVENT_SOFT_CREDIT_INPUT,
  "msg": DM_EVENT_MESSAGING_INPUT,
  "c": DM_EVENT_CONTACT_INPUT,
  "appo": DM_EVENT_APPOINTMENT_INPUT
};
var DEFAULT_CREDIT_TIERS = [{
  id: 0,
  label: "Ultra (800-899)",
  low: 800,
  high: 899
}, {
  id: 1,
  label: "Super Elite (740-799)",
  low: 740,
  high: 799
}, {
  id: 2,
  label: "Elite (700-739)",
  low: 700,
  high: 739
}, {
  id: 3,
  label: "Standard (675-699)",
  low: 675,
  high: 699
}, {
  id: 4,
  label: "Standard Plus (640-674)",
  low: 640,
  high: 674
}, {
  id: 5,
  label: "Progressive (601-639)",
  low: 601,
  high: 639
}, {
  id: 6,
  label: "PRPL (575-600)",
  low: 575,
  high: 600
}, {
  id: -1,
  label: "Not Sure"
}];
var DMField = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var ddOptions = props.options || [];
  if (props.name == DR_CREDIT_TIER && !props.options) {
    ddOptions = DEFAULT_CREDIT_TIERS;
  }
  if (props.name == DR_CREDIT_TIER) console.log(props.name, ddOptions);
  var _useState = React.useState(false),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    initialized = _useState2[0],
    setInitialize = _useState2[1];
  var _useState3 = React.useState(props.value),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = React.useState(),
    _useState6 = _slicedToArray__default["default"](_useState5, 2);
    _useState6[0];
    var setDDIcon = _useState6[1];
  var _useState7 = React.useState(1),
    _useState8 = _slicedToArray__default["default"](_useState7, 2),
    salt = _useState8[0],
    setSalt = _useState8[1];
  var _useState9 = React.useState(ddOptions),
    _useState10 = _slicedToArray__default["default"](_useState9, 2),
    options = _useState10[0],
    setOptions = _useState10[1];
  var fieldRef = React.useRef();
  var fieldId = props.name; // + "_" + new Date().getTime()

  // Field specific metadata mapping
  // By default it is a text field, which does not require any mapping
  var fieldMeta = {};
  fieldMeta[DR_CASH_DOWN] = {
    type: "text"
  };
  fieldMeta[TRADE_VEHICLE_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[SOFT_CREDIT_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[DR_CREDIT_TIER] = {
    type: "select",
    options: DEFAULT_CREDIT_TIERS
  };
  // Deal options are dynamically loaded
  fieldMeta[DR_FINANCE_TERM] = {
    type: "select",
    options: []
  };
  fieldMeta[DR_LEASE_MILES] = {
    type: "select",
    options: []
  };
  fieldMeta[DR_LEASE_TERM] = {
    type: "select",
    options: []
  };
  fieldMeta[DR_OFFER] = {
    type: "checkbox",
    options: [],
    idAttr: 'offer_id'
  };
  fieldMeta[DR_PLAN] = {
    type: "checkbox",
    options: [],
    idAttr: 'product_id'
  };
  fieldMeta[TRADE_VEHICLE_ID_TYPE] = {
    type: "hidden",
    options: []
  };
  fieldMeta[TRADE_VEHICLE_OPTION] = {
    type: "checkbox",
    options: [],
    idAttr: 'option_id'
  };
  fieldMeta[TRADE_VEHICLE_CONDITION] = {
    type: "select",
    options: []
  };
  fieldMeta[CREDIT_APP_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_PREV_ADDR_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_CO_APP_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_CO_APP_PREV_ADDR_STATE] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_HOUSING_STATUS] = {
    type: "select",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_MORTGAGE_RENT] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_TIME_AT_JOB_YEARS] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_TIME_AT_JOB_MONTHS] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_TIME_AT_ADDR_YEARS] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_TIME_AT_ADDR_MONTHS] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_INCOME] = {
    type: "number",
    options: US_STATES
  };
  fieldMeta[CREDIT_APP_HOUSING_STATUS] = {
    type: "select",
    options: function options(config) {
      return config.credit_app ? config.credit_app.enums['housing_status'] : [];
    }
  };
  fieldMeta[CREDIT_APP_INCOME_TYPE] = {
    type: "select",
    options: function options(config) {
      return config.credit_app ? config.credit_app.enums['income_type'] : [];
    }
  };
  fieldMeta[CREDIT_APP_INCOME_INTERVAL] = {
    type: "select",
    options: function options(config) {
      return config.credit_app ? config.credit_app.enums['salary_interval'] : [];
    }
  };
  fieldMeta[CREDIT_APP_EMPLOYMENT_STATUS] = {
    type: "select",
    options: function options(config) {
      return config.credit_app ? config.credit_app.enums['emp_type'] : [];
    }
  };
  fieldMeta[DOCUMENT] = {
    type: "file",
    options: []
  };
  fieldMeta[MESSAGING_BODY] = {
    type: "textarea",
    options: []
  };

  // fieldMeta[APPOINTMENT_VEHICLE_VIN] = { type: "text", blur: true }

  var meta = Object.assign(fieldMeta[props.name] || {}, props);
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setDDIcon(ApiUtils.config.ddIcon);
    setupField();
  });
  useDMEventListener(DM_EVENT_DR_DEAL_TERMS, function (event) {
    // Listener for Deal Terms load
    if (props.name == DR_LEASE_TERM && event.detail && event.detail.lease && event.detail.lease.terms && event.detail.lease.terms.length > 0) setOptions(event.detail.lease.terms);
    if (props.name == DR_LEASE_MILES && event.detail && event.detail.lease && event.detail.lease.mileage && event.detail.lease.mileage.length > 0) setOptions(event.detail.lease.mileage);
    if (props.name == DR_FINANCE_TERM && event.detail && event.detail.finance && event.detail.finance.terms && event.detail.finance.terms.length > 0) setOptions(event.detail.finance.terms);
  });
  useDMEventListener(DM_EVENT_FIELD_OPTIONS + "_" + props.name, function (event) {
    setOptions(event.detail.options && event.detail.options.length > 0 ? event.detail.options : props.options || event.detail.options);
  });
  useDMEventListener(DM_EVENT_FIELD_VALUE_UPDATE, function (event) {
    if (event.detail[props.name]) {
      setValue(event.detail[props.name]);
    } else if (event.detail.prop_name == props.name) {
      if (value[event.detail.prop_id] == event.detail.id) {
        setValue(event.detail.value);
      }
    }
  });
  React.useEffect(function () {
    if (props.type == 'hidden' || meta.type == 'hidden') {
      setValue(props.value);
      setTimeout(function () {
        if (initialized) triggerChangeEvent(props.name, props.value);
      }, 100);
      setInitialize(true);
    }
  }, [props.value]);
  React.useEffect(function () {
    setupField();
  }, []);

  // useDMEventListener(DM_EVENT_DR_PLAN_SYNC, event => {
  //   if (event.detail && event.detail.product_id == value.product_id) {
  //     let v = Object.assign({}, value)
  //     v.selected = false
  //     setValue(v)
  //   }
  // })

  React.useImperativeHandle(ref, function () {
    return {
      value: value,
      setValue: setValue
    };
  });
  var setupField = function setupField() {
    if (props.name == DR_LEASE_TERM || props.name == DR_LEASE_MILES || props.name == DR_FINANCE_TERM) {
      setTimeout(function () {
        emitDMEvent(DM_EVENT_DR_DEAL_TERMS_REFRESH);
      }, 100);
    } else if (props.name == TRADE_VEHICLE_CONDITION) {
      setTimeout(function () {
        emitDMEvent(DM_EVENT_TRADE_CONFIG_REFRESH);
      }, 500);
    } else {
      var _options = fieldMeta[props.name] ? fieldMeta[props.name].options : props.options;
      if (typeof _options == 'function' && ApiUtils.config) {
        var formOptions = _options(ApiUtils.config);
        if (fieldMeta[props.name]) setOptions(formOptions);
      } else {
        if (fieldMeta[props.name]) setOptions(_options);
      }
    }
  };
  var onFieldChange = function onFieldChange(e) {
    var field = e.target;
    var val = field.value;
    if (val && props.numbersOnly) {
      val = val.match(/(\d+)/)[0];
    }
    setValue(val);
    var valueChanged = value != val;
    if (valueChanged && (!fieldMeta[props.name] || !fieldMeta[props.name].blur)) {
      triggerChangeEvent(props.name, val);
      logFieldChangeEvent(field);
    }
  };
  var onCheckboxToggle = function onCheckboxToggle(e) {
    var field = e.target;
    var val = Object.assign({}, value, {
      selected: !value.selected
    });
    var valueChanged = value != val;
    if (valueChanged) {
      setValue(val);
      setSalt(new Date().getTime());
      triggerChangeEvent(props.name, val, 'item');
      logFieldChangeEvent(field);
    }
  };
  var onFieldBlur = function onFieldBlur(e) {
    var field = e.target;
    if (fieldMeta[props.name] && fieldMeta[props.name].blur) {
      var val = e.target.value;
      triggerChangeEvent(props.name, val);
      logFieldChangeEvent(field);
    }
    if (props.onBlur) props.onBlur(e);
  };
  var onFieldFocus = function onFieldFocus(e) {
    if (props.onFocus) props.onFocus(e);
  };
  var onFileSelect = function onFileSelect(e) {
    emitDMEvent(DM_EVENT_FILE_SELECT, {
      type: props.type,
      file: event.target.files[0]
    });
  };
  var defaultAriaLabel = function defaultAriaLabel() {
    if (fieldMeta[props.name]) {
      var s = props.name.split("_").slice(1).join(" ");
      return s[0].toUpperCase() + s.slice(1);
    } else {
      return props.name;
    }
  };
  var triggerChangeEvent = function triggerChangeEvent(field, val, key) {
    if (props.onChange) props.onChange(field, val);
    var eventName = FIELD_EVENT[props.name.split("_")[0]];
    if (eventName) {
      var params = {};
      params["name"] = key || field;
      params["value"] = val;
      params["form_id"] == fieldRef.current.form ? fieldRef.current.form.id : null;
      params["options"] = options;
      emitDMEvent(eventName, params);
    }
    emitDMEvent("field_" + field, val);
  };
  var renderField = function renderField() {
    if (props.hidden || meta.type == 'hidden') {
      if (meta.type == 'checkbox') {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "checkbox",
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          "aria-hidden": true,
          onChange: function onChange(e) {
            return onCheckboxToggle(e);
          },
          style: {
            opacity: 0,
            position: 'absolute'
          }
        });
      } else {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "hidden",
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          "aria-hidden": true,
          onChange: function onChange(e) {
            return onFieldChange(e);
          }
        });
      }
    } else if (meta.type && meta.type != 'text' && meta.type != 'password') {
      if (meta.type == 'select') {
        return /*#__PURE__*/React__default["default"].createElement("div", {
          className: "form-with"
        }, /*#__PURE__*/React__default["default"].createElement("select", {
          ref: fieldRef,
          id: props.id || fieldId,
          className: props.className || '',
          style: props.style || {},
          value: value || props.value || '',
          name: props.name,
          onChange: function onChange(e) {
            return onFieldChange(e);
          },
          tabIndex: "0",
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          }
        }, props.allowEmpty && /*#__PURE__*/React__default["default"].createElement("option", {
          value: ""
        }), props.placeholder && !props.allowEmpty && /*#__PURE__*/React__default["default"].createElement("option", {
          value: "",
          disabled: !value
        }, props.placeholder), options === null || options === void 0 ? void 0 : options.map(function (t, i) {
          return /*#__PURE__*/React__default["default"].createElement("option", {
            key: t.id || t.key || t,
            value: t.id || t.key || t
          }, props.prefix || '', " ", t.label || t.name || t, " ", props.suffix || '');
        })));
      }
      if (meta.type == 'checkbox' && value) {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          key: salt,
          id: props.id || props.name + "_" + value[meta.idAttr],
          name: props.name,
          checked: value.selected ? 'checked' : '',
          type: "checkbox",
          onChange: function onChange(e) {
            return onCheckboxToggle(e);
          },
          tabIndex: "0",
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          }
        });
      }
      if (meta.type == 'number') {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "number",
          className: props.className || '',
          value: value || '',
          style: props.style || {},
          onChange: function onChange(e) {
            return onFieldChange(e);
          },
          onBlur: function onBlur(e) {
            return onFieldBlur(e);
          },
          tabIndex: "0",
          placeholder: props.placeholder,
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          }
        });
      }
      if (meta.type == 'date') {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "date",
          className: props.className || '',
          value: value || '',
          style: props.style || {},
          onChange: function onChange(e) {
            return onFieldChange(e);
          },
          onBlur: function onBlur(e) {
            return onFieldBlur(e);
          },
          tabIndex: "0",
          placeholder: props.placeholder,
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          }
        });
      }
      if (meta.type == 'textarea') {
        return /*#__PURE__*/React__default["default"].createElement("textarea", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          className: props.className || '',
          value: value || '',
          style: props.style || {},
          onChange: function onChange(e) {
            return onFieldChange(e);
          },
          onBlur: function onBlur(e) {
            return onFieldBlur(e);
          },
          tabIndex: "0",
          placeholder: props.placeholder,
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          },
          maxLength: props.maxLength
        });
      }
      if (meta.type == 'file') {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "file",
          className: props.className || '',
          style: props.style || {},
          onChange: function onChange(e) {
            return onFileSelect();
          },
          tabIndex: "0",
          placeholder: props.placeholder,
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          onFocus: function onFocus(e) {
            return onFieldFocus(e);
          }
        });
      }
      if (meta.type == 'slider') {
        return /*#__PURE__*/React__default["default"].createElement("input", {
          ref: fieldRef,
          id: props.id || fieldId,
          name: props.name,
          type: "range",
          className: props.className || '',
          style: props.style || {},
          onChange: function onChange(e) {
            return onFieldChange(e);
          },
          min: props.min,
          max: props.max,
          value: value || '',
          step: props.step,
          tabIndex: "0",
          placeholder: props.placeholder,
          "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
          disabled: props.disabled
        });
      }
    } else {
      return /*#__PURE__*/React__default["default"].createElement("input", {
        ref: fieldRef,
        id: props.id || fieldId,
        name: props.name,
        type: meta.type || 'text',
        className: props.className || '',
        value: value || '',
        style: props.style || {},
        onChange: function onChange(e) {
          return onFieldChange(e);
        },
        onBlur: function onBlur(e) {
          return onFieldBlur(e);
        },
        tabIndex: "0",
        placeholder: props.placeholder,
        "aria-label": props.placeholder || meta.label || defaultAriaLabel(),
        onFocus: function onFocus(e) {
          return onFieldFocus(e);
        },
        maxLength: props.maxLength
      });
    }
  };
  if (props.disabled && props.onDisabledClick) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        display: 'block',
        position: 'relative'
      }
    }, renderField(), /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        display: 'block',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      },
      onClick: function onClick(e) {
        return props.onDisabledClick(e);
      },
      onTouchStart: function onTouchStart(e) {
        return props.onDisabledClick(e);
      }
    }));
  } else {
    return renderField();
  }
});
DMField.displayName = 'DMField';

var DMFields = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DR_DEAL_TYPE: DR_DEAL_TYPE,
  DR_CASH_DOWN: DR_CASH_DOWN,
  DR_CREDIT_TIER: DR_CREDIT_TIER,
  DR_FINANCE_TERM: DR_FINANCE_TERM,
  DR_LEASE_MILES: DR_LEASE_MILES,
  DR_LEASE_TERM: DR_LEASE_TERM,
  DR_TRADE_VALUE: DR_TRADE_VALUE,
  DR_TRADE_PAYOFF: DR_TRADE_PAYOFF,
  DR_OFFER: DR_OFFER,
  DR_PLAN: DR_PLAN,
  CREDIT_APP_FIRST_NAME: CREDIT_APP_FIRST_NAME,
  CREDIT_APP_MIDDLE_NAME: CREDIT_APP_MIDDLE_NAME,
  CREDIT_APP_LAST_NAME: CREDIT_APP_LAST_NAME,
  CREDIT_APP_SUFFIX: CREDIT_APP_SUFFIX,
  CREDIT_APP_EMAIL: CREDIT_APP_EMAIL,
  CREDIT_APP_PHONE: CREDIT_APP_PHONE,
  CREDIT_APP_MOBILE_PHONE: CREDIT_APP_MOBILE_PHONE,
  CREDIT_APP_ADDRESS: CREDIT_APP_ADDRESS,
  CREDIT_APP_ADDRESS_2: CREDIT_APP_ADDRESS_2,
  CREDIT_APP_CITY: CREDIT_APP_CITY,
  CREDIT_APP_STATE: CREDIT_APP_STATE,
  CREDIT_APP_ZIP: CREDIT_APP_ZIP,
  CREDIT_APP_SSN: CREDIT_APP_SSN,
  CREDIT_APP_DOB: CREDIT_APP_DOB,
  CREDIT_APP_ADDR_LESS_2Y: CREDIT_APP_ADDR_LESS_2Y,
  CREDIT_APP_PREV_ADDR_ADDRESS: CREDIT_APP_PREV_ADDR_ADDRESS,
  CREDIT_APP_PREV_ADDR_CITY: CREDIT_APP_PREV_ADDR_CITY,
  CREDIT_APP_PREV_ADDR_STATE: CREDIT_APP_PREV_ADDR_STATE,
  CREDIT_APP_PREV_ADDR_ZIP: CREDIT_APP_PREV_ADDR_ZIP,
  CREDIT_APP_HOUSING_STATUS: CREDIT_APP_HOUSING_STATUS,
  CREDIT_APP_MORTGAGE_RENT: CREDIT_APP_MORTGAGE_RENT,
  CREDIT_APP_TIME_AT_ADDR_YEARS: CREDIT_APP_TIME_AT_ADDR_YEARS,
  CREDIT_APP_TIME_AT_ADDR_MONTHS: CREDIT_APP_TIME_AT_ADDR_MONTHS,
  CREDIT_APP_INCOME_TYPE: CREDIT_APP_INCOME_TYPE,
  CREDIT_APP_INCOME_INTERVAL: CREDIT_APP_INCOME_INTERVAL,
  CREDIT_APP_INCOME: CREDIT_APP_INCOME,
  CREDIT_APP_OTHER_INCOME_TYPE: CREDIT_APP_OTHER_INCOME_TYPE,
  CREDIT_APP_OTHER_INCOME_INTERVAL: CREDIT_APP_OTHER_INCOME_INTERVAL,
  CREDIT_APP_OTHER_INCOME: CREDIT_APP_OTHER_INCOME,
  CREDIT_APP_OTHER_INCOME_SOURCE: CREDIT_APP_OTHER_INCOME_SOURCE,
  CREDIT_APP_EMPLOYMENT_STATUS: CREDIT_APP_EMPLOYMENT_STATUS,
  CREDIT_APP_EMPLOYER: CREDIT_APP_EMPLOYER,
  CREDIT_APP_JOB_TITLE: CREDIT_APP_JOB_TITLE,
  CREDIT_APP_WORK_PHONE: CREDIT_APP_WORK_PHONE,
  CREDIT_APP_TIME_AT_JOB_YEARS: CREDIT_APP_TIME_AT_JOB_YEARS,
  CREDIT_APP_TIME_AT_JOB_MONTHS: CREDIT_APP_TIME_AT_JOB_MONTHS,
  CREDIT_APP_PREV_EMPLOYMENT_STATUS: CREDIT_APP_PREV_EMPLOYMENT_STATUS,
  CREDIT_APP_PREV_EMPLOYER: CREDIT_APP_PREV_EMPLOYER,
  CREDIT_APP_PREV_JOB_TITLE: CREDIT_APP_PREV_JOB_TITLE,
  CREDIT_APP_PREV_WORK_PHONE: CREDIT_APP_PREV_WORK_PHONE,
  CREDIT_APP_PREV_TIME_AT_JOB_YEARS: CREDIT_APP_PREV_TIME_AT_JOB_YEARS,
  CREDIT_APP_PREV_TIME_AT_JOB_MONTHS: CREDIT_APP_PREV_TIME_AT_JOB_MONTHS,
  CREDIT_APP_HAVE_CO_APP: CREDIT_APP_HAVE_CO_APP,
  CREDIT_APP_CO_APP_FIRST_NAME: CREDIT_APP_CO_APP_FIRST_NAME,
  CREDIT_APP_CO_APP_MIDDLE_NAME: CREDIT_APP_CO_APP_MIDDLE_NAME,
  CREDIT_APP_CO_APP_LAST_NAME: CREDIT_APP_CO_APP_LAST_NAME,
  CREDIT_APP_CO_APP_SUFFIX: CREDIT_APP_CO_APP_SUFFIX,
  CREDIT_APP_CO_APP_EMAIL: CREDIT_APP_CO_APP_EMAIL,
  CREDIT_APP_CO_APP_PHONE: CREDIT_APP_CO_APP_PHONE,
  CREDIT_APP_CO_APP_MOBILE_PHONE: CREDIT_APP_CO_APP_MOBILE_PHONE,
  CREDIT_APP_CO_APP_ADDRESS: CREDIT_APP_CO_APP_ADDRESS,
  CREDIT_APP_CO_APP_ADDRESS_2: CREDIT_APP_CO_APP_ADDRESS_2,
  CREDIT_APP_CO_APP_CITY: CREDIT_APP_CO_APP_CITY,
  CREDIT_APP_CO_APP_STATE: CREDIT_APP_CO_APP_STATE,
  CREDIT_APP_CO_APP_ZIP: CREDIT_APP_CO_APP_ZIP,
  CREDIT_APP_CO_APP_SSN: CREDIT_APP_CO_APP_SSN,
  CREDIT_APP_CO_APP_DOB: CREDIT_APP_CO_APP_DOB,
  CREDIT_APP_CO_APP_ADDR_LESS_2Y: CREDIT_APP_CO_APP_ADDR_LESS_2Y,
  CREDIT_APP_CO_APP_PREV_ADDR_ADDRESS: CREDIT_APP_CO_APP_PREV_ADDR_ADDRESS,
  CREDIT_APP_CO_APP_PREV_ADDR_CITY: CREDIT_APP_CO_APP_PREV_ADDR_CITY,
  CREDIT_APP_CO_APP_PREV_ADDR_STATE: CREDIT_APP_CO_APP_PREV_ADDR_STATE,
  CREDIT_APP_CO_APP_PREV_ADDR_ZIP: CREDIT_APP_CO_APP_PREV_ADDR_ZIP,
  CREDIT_APP_CO_APP_HOUSING_STATUS: CREDIT_APP_CO_APP_HOUSING_STATUS,
  CREDIT_APP_CO_APP_MORTGAGE_RENT: CREDIT_APP_CO_APP_MORTGAGE_RENT,
  CREDIT_APP_CO_APP_TIME_AT_ADDR_YEARS: CREDIT_APP_CO_APP_TIME_AT_ADDR_YEARS,
  CREDIT_APP_CO_APP_TIME_AT_ADDR_MONTHS: CREDIT_APP_CO_APP_TIME_AT_ADDR_MONTHS,
  CREDIT_APP_CO_APP_INCOME_TYPE: CREDIT_APP_CO_APP_INCOME_TYPE,
  CREDIT_APP_CO_APP_INCOME_INTERVAL: CREDIT_APP_CO_APP_INCOME_INTERVAL,
  CREDIT_APP_CO_APP_INCOME: CREDIT_APP_CO_APP_INCOME,
  CREDIT_APP_CO_APP_OTHER_INCOME_TYPE: CREDIT_APP_CO_APP_OTHER_INCOME_TYPE,
  CREDIT_APP_CO_APP_OTHER_INCOME_INTERVAL: CREDIT_APP_CO_APP_OTHER_INCOME_INTERVAL,
  CREDIT_APP_CO_APP_OTHER_INCOME: CREDIT_APP_CO_APP_OTHER_INCOME,
  CREDIT_APP_CO_APP_OTHER_INCOME_SOURCE: CREDIT_APP_CO_APP_OTHER_INCOME_SOURCE,
  CREDIT_APP_CO_APP_EMPLOYMENT_STATUS: CREDIT_APP_CO_APP_EMPLOYMENT_STATUS,
  CREDIT_APP_CO_APP_EMPLOYER: CREDIT_APP_CO_APP_EMPLOYER,
  CREDIT_APP_CO_APP_JOB_TITLE: CREDIT_APP_CO_APP_JOB_TITLE,
  CREDIT_APP_CO_APP_WORK_PHONE: CREDIT_APP_CO_APP_WORK_PHONE,
  CREDIT_APP_CO_APP_TIME_AT_JOB_YEARS: CREDIT_APP_CO_APP_TIME_AT_JOB_YEARS,
  CREDIT_APP_CO_APP_TIME_AT_JOB_MONTHS: CREDIT_APP_CO_APP_TIME_AT_JOB_MONTHS,
  CREDIT_APP_CO_APP_PREV_EMPLOYMENT_STATUS: CREDIT_APP_CO_APP_PREV_EMPLOYMENT_STATUS,
  CREDIT_APP_CO_APP_PREV_EMPLOYER: CREDIT_APP_CO_APP_PREV_EMPLOYER,
  CREDIT_APP_CO_APP_PREV_JOB_TITLE: CREDIT_APP_CO_APP_PREV_JOB_TITLE,
  CREDIT_APP_CO_APP_PREV_WORK_PHONE: CREDIT_APP_CO_APP_PREV_WORK_PHONE,
  CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_YEARS: CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_YEARS,
  CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_MONTHS: CREDIT_APP_CO_APP_PREV_TIME_AT_JOB_MONTHS,
  TRADE_VEHICLE_ID_TYPE: TRADE_VEHICLE_ID_TYPE,
  TRADE_VEHICLE_PLATE: TRADE_VEHICLE_PLATE,
  TRADE_VEHICLE_STATE: TRADE_VEHICLE_STATE,
  TRADE_VEHICLE_VIN: TRADE_VEHICLE_VIN,
  TRADE_VEHICLE_MILES: TRADE_VEHICLE_MILES,
  TRADE_VEHICLE_ZIP: TRADE_VEHICLE_ZIP,
  TRADE_VEHICLE_CONDITION: TRADE_VEHICLE_CONDITION,
  TRADE_VEHICLE_OPTION: TRADE_VEHICLE_OPTION,
  TRADE_VEHICLE_PAYOFF: TRADE_VEHICLE_PAYOFF,
  SOFT_CREDIT_FIRST_NAME: SOFT_CREDIT_FIRST_NAME,
  SOFT_CREDIT_LAST_NAME: SOFT_CREDIT_LAST_NAME,
  SOFT_CREDIT_EMAIL: SOFT_CREDIT_EMAIL,
  SOFT_CREDIT_PHONE: SOFT_CREDIT_PHONE,
  SOFT_CREDIT_ADDRESS: SOFT_CREDIT_ADDRESS,
  SOFT_CREDIT_CITY: SOFT_CREDIT_CITY,
  SOFT_CREDIT_STATE: SOFT_CREDIT_STATE,
  SOFT_CREDIT_ZIP: SOFT_CREDIT_ZIP,
  CONTACT_FIRST_NAME: CONTACT_FIRST_NAME,
  CONTACT_LAST_NAME: CONTACT_LAST_NAME,
  CONTACT_EMAIL: CONTACT_EMAIL,
  CONTACT_PHONE: CONTACT_PHONE,
  CONTACT_MOBILE_PHONE: CONTACT_MOBILE_PHONE,
  CONTACT_ZIP: CONTACT_ZIP,
  APPOINTMENT_FIRST_NAME: APPOINTMENT_FIRST_NAME,
  APPOINTMENT_LAST_NAME: APPOINTMENT_LAST_NAME,
  APPOINTMENT_EMAIL: APPOINTMENT_EMAIL,
  APPOINTMENT_PHONE: APPOINTMENT_PHONE,
  APPOINTMENT_DATE: APPOINTMENT_DATE,
  APPOINTMENT_TIME: APPOINTMENT_TIME,
  APPOINTMENT_DATETIME: APPOINTMENT_DATETIME,
  APPOINTMENT_OPTIONS: APPOINTMENT_OPTIONS,
  APPOINTMENT_VEHICLE_VIN: APPOINTMENT_VEHICLE_VIN,
  APPOINTMENT_VEHICLE_YEAR: APPOINTMENT_VEHICLE_YEAR,
  APPOINTMENT_VEHICLE_MAKE: APPOINTMENT_VEHICLE_MAKE,
  APPOINTMENT_VEHICLE_MODEL: APPOINTMENT_VEHICLE_MODEL,
  DOCUMENT: DOCUMENT,
  MESSAGING_BODY: MESSAGING_BODY,
  FIELD_EVENT: FIELD_EVENT,
  'default': DMField
});

var DMProvider = function DMProvider(props) {
  var _config$data_layers, _config$data_layers2;
  var _useState = React.useState(),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    config = _useState2[0],
    setConfig = _useState2[1];
  useDMEventListener(DM_LOG_EVENT, function (event) {
    logEvent$1(event.detail);
  });
  React.useEffect(function () {
    ApiUtils.eventSessionId = new Date().getTime();
    window._dmData = {};
    if (props.visitorId) {
      if (localStorage) localStorage.setItem("_dm_vid", props.visitorId);
    }
    ApiUtils.server = props.config.server || "https://api.dealermesh.com";
    ApiUtils.accessToken = props.config.accessToken;
    ApiUtils.dealerAccessKey = props.config.accessKey;
    ApiUtils.clientId = props.config.clientId;
    ApiUtils.pageName = props.config.page;
    ApiUtils.getRequest("/v1/dealers/component_config?domain=" + window.location.hostname).then(function (data) {
      if (data && !data.code) {
        ApiUtils.eventToken = data.event_token;
        setConfig(data);
        ApiUtils.config = Object.assign({}, props.config, data);
        ApiUtils.config.ddIcon = props.config.ddIcon;
        emitDMEvent(DM_EVENT_CONFIG_LOADED);
        if (!(localStorage && localStorage.getItem("_dm_vid"))) {
          var vid = props.visitorId || uuid__default["default"]();
          if (localStorage) localStorage.setItem("_dm_vid", vid);
          ApiUtils.postRequest("/v1/visitors/info", {
            vid: vid,
            ip: ApiUtils.config.ip_address
          }).then(function (data) {
            if (data) {
              if (localStorage) localStorage.setItem("_dm_sid", data.session_id);
              emitDMEvent(DM_EVENT_VISITOR_IDS, {
                visitor_id: vid,
                session_id: data.session_id
              });
              // AppStore.setVisitor(data)
            }
          });
        } else {
          var sessionId = useVisitorSessionId();
          ApiUtils.postRequest("/v1/visitors/info", {
            vid: useVisitorId(),
            sid: sessionId,
            ip: ApiUtils.config.ip_address
          }).then(function (data) {
            if (data) {
              if (localStorage) localStorage.setItem("_dm_sid", data.session_id);
              emitDMEvent(DM_EVENT_VISITOR_IDS, {
                visitor_id: useVisitorId(),
                session_id: data.session_id
              });
              // AppStore.setVisitor(data)
            }
          });
        }
      } else {
        emitDMEvent(EVENT_DM_ERROR, data);
      }
    });
    logEvent$1("page", "view", null, {}, props);
  }, []);
  var children = props.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: props.className || ''
  }, children, (config === null || config === void 0 ? void 0 : (_config$data_layers = config.data_layers) === null || _config$data_layers === void 0 ? void 0 : _config$data_layers.map) && (config === null || config === void 0 ? void 0 : (_config$data_layers2 = config.data_layers) === null || _config$data_layers2 === void 0 ? void 0 : _config$data_layers2.map(function (dl, index) {
    return dl.partner == 'ga4' && dl.config.enabled ? /*#__PURE__*/React__default["default"].createElement(GA4, {
      key: index,
      id: dl.config.client_id
    }) : dl.partner == 'sd' && dl.config.enabled ? /*#__PURE__*/React__default["default"].createElement(ShiftDigitalTagging, {
      key: index,
      config: dl.config
    }) : dl.partner == 'pixall' && dl.config.enabled ? /*#__PURE__*/React__default["default"].createElement(PixallAnalytics, {
      key: index,
      config: dl.config
    }) : dl.partner == 'adobe' && dl.config.enabled ? /*#__PURE__*/React__default["default"].createElement(AdobeAnalytics, {
      key: index,
      config: dl.config
    }) : null;
  })));
};
function logDMEvent(name, type, component, data, props) {
  logEvent$1(name, type, component, data, props);
}

var TRADE_STATUS_NEW = 1;
var TRADE_STATUS_APPLIED = 2;
function onDMApplyTradeToDeal(event) {
  if (event) event.preventDefault();
  emitDMEvent(DM_EVENT_TRADE_APPLY_DEAL);
}
function onDMRemoveTradeFromDeal(event) {
  if (event) event.preventDefault();
  emitDMEvent(DM_EVENT_TRADE_REMOVE_DEAL);
}

var DMTrade = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TRADE_STATUS_NEW: TRADE_STATUS_NEW,
  TRADE_STATUS_APPLIED: TRADE_STATUS_APPLIED,
  onDMApplyTradeToDeal: onDMApplyTradeToDeal,
  onDMRemoveTradeFromDeal: onDMRemoveTradeFromDeal
});

var allDealTypes = ['lease', 'finance', 'cash'];
var DMDRProvider = function DMDRProvider(props) {
  var _props$car, _props$car2, _props$car3, _props$car4, _props$car5, _props$car6, _props$car7, _props$car8, _props$car9;
  var _useState = React.useState(Object.assign({}, props.car, {
      vin: props.vin || ((_props$car = props.car) === null || _props$car === void 0 ? void 0 : _props$car.vin),
      stock_number: props.stockNumber || ((_props$car2 = props.car) === null || _props$car2 === void 0 ? void 0 : _props$car2.stock_number),
      condition: props.condition || ((_props$car3 = props.car) === null || _props$car3 === void 0 ? void 0 : _props$car3.condition) || 'new',
      msrp: props.msrp || ((_props$car4 = props.car) === null || _props$car4 === void 0 ? void 0 : _props$car4.msrp),
      price: props.price || ((_props$car5 = props.car) === null || _props$car5 === void 0 ? void 0 : _props$car5.price),
      year: props.year || ((_props$car6 = props.car) === null || _props$car6 === void 0 ? void 0 : _props$car6.year),
      make_name: props.make || ((_props$car7 = props.car) === null || _props$car7 === void 0 ? void 0 : _props$car7.make_name),
      model_name: props.model || ((_props$car8 = props.car) === null || _props$car8 === void 0 ? void 0 : _props$car8.model_name),
      trim_name: props.trim || ((_props$car9 = props.car) === null || _props$car9 === void 0 ? void 0 : _props$car9.trim_name)
    })),
    _useState2 = _slicedToArray__default["default"](_useState, 1),
    car = _useState2[0];
  var _useState3 = React.useState(props.zip || car.zip_code || ApiUtils.config.zip),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    zip = _useState4[0],
    setZip = _useState4[1];
  var _useState5 = React.useState(),
    _useState6 = _slicedToArray__default["default"](_useState5, 2),
    dealType = _useState6[0],
    setDealType = _useState6[1];
  var _useState7 = React.useState(),
    _useState8 = _slicedToArray__default["default"](_useState7, 2),
    deal = _useState8[0],
    setDeal = _useState8[1];
  var _useState9 = React.useState(),
    _useState10 = _slicedToArray__default["default"](_useState9, 2),
    terms = _useState10[0],
    setTerms = _useState10[1];
  var _useState11 = React.useState(),
    _useState12 = _slicedToArray__default["default"](_useState11, 2),
    offers = _useState12[0],
    setOffers = _useState12[1];
  var _useState13 = React.useState(),
    _useState14 = _slicedToArray__default["default"](_useState13, 2),
    plans = _useState14[0],
    setPlans = _useState14[1];
  var _useState15 = React.useState(props.creditTier || 1),
    _useState16 = _slicedToArray__default["default"](_useState15, 2),
    creditTier = _useState16[0],
    setCreditTier = _useState16[1];
  var _useState17 = React.useState(props.creditScore || 900),
    _useState18 = _slicedToArray__default["default"](_useState17, 2);
    _useState18[0];
    var setCreditScore = _useState18[1];
  var _useState19 = React.useState(),
    _useState20 = _slicedToArray__default["default"](_useState19, 2),
    tradeId = _useState20[0],
    setTradeId = _useState20[1];
  var _useState21 = React.useState(props.tradeInValue || 0),
    _useState22 = _slicedToArray__default["default"](_useState21, 2),
    tradeValue = _useState22[0],
    setTradeValue = _useState22[1];
  var _useState23 = React.useState(props.tradePayoff || 0),
    _useState24 = _slicedToArray__default["default"](_useState23, 2),
    tradePayoff = _useState24[0],
    setTradePayoff = _useState24[1];
  if (!car.vin || !(car.condition != 'new' || car.condition == 'new' && car.msrp) || !car.price) {
    throw "DM Error: VIN and Price are required. MSRP is required for new cars.";
  }
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    calcPayment();
  });
  useDMEventListener(DM_EVENT_DR_DEAL_REQUEST, function (event) {
    emitDMEvent(DM_EVENT_DR_DEAL_SYNC, deal);
  });
  useDMEventListener(DM_EVENT_DR_DEAL_PARAM_CHANGE, function (event) {
    reCalc(event.detail);
    Object.keys(event.detail).map(function (key) {
      logEvent$1("dr", "change", key, event.detail, Object.assign({}, props, {
        car: car
      }));
    });
  });
  useDMEventListener(DM_EVENT_DR_DEAL_TYPE_REQUEST, function (event) {
    emitDMEvent(DM_EVENT_DR_DEAL_TYPE_SYNC, {
      dealType: dealType
    });
  });
  useDMEventListener(DM_EVENT_DR_OFFER_TOGGLE, function (event) {
    onOfferToggle(event.detail);
  });
  useDMEventListener(DM_EVENT_DR_PLAN_TOGGLE, function (event) {
    onPlanToggle(event.detail);
  });
  useDMEventListener(DM_EVENT_DR_OFFERS_LOADED, function (event) {
    Object.keys(event.detail).map(function (type) {
      if (deal.params[type] && deal.params[type]['offers'] && deal.params[type]['offers'].length > 0) {
        var selectedOfferIds = [];
        deal.params[type]['offers'].map(function (ofr) {
          selectedOfferIds.push(ofr.offer_id);
        });
        event.detail[type].consumer.cash.map(function (ofr) {
          if (selectedOfferIds.includes(ofr.offer_id)) ofr.selected = true;
        });
        event.detail[type].consumer.specials.map(function (ofr) {
          if (selectedOfferIds.includes(ofr.offer_id)) ofr.selected = true;
        });
        event.detail[type].dealer.cash.map(function (ofr) {
          if (selectedOfferIds.includes(ofr.offer_id)) ofr.selected = true;
        });
        event.detail[type].dealer.specials.map(function (ofr) {
          if (selectedOfferIds.includes(ofr.offer_id)) ofr.selected = true;
        });
      }
    });
    setOffers(event.detail);
  });
  useDMEventListener(DM_EVENT_DR_OFFERS_SYNC, function (event) {
    emitDMEvent(DM_EVENT_DR_OFFERS_DATA, offers);
  });
  useDMEventListener(DM_EVENT_DR_PLAN_SYNC, function (event) {
    var data = _toConsumableArray__default["default"](plans);
    data.map(function (p) {
      if (event.detail && event.detail.product_id == p.product_id) {
        p.selected = false;
      }
    });
    setPlans(data);
  });
  useDMEventListener(DM_EVENT_DR_DEAL_TYPE_CHANGE, function (event) {
    var type = event.detail.type;
    setDealType(type);
    emitDMEvent(DM_EVENT_DR_DEAL_TYPE_SYNC, {
      dealType: type
    });
    logEvent$1("dr", "change", "deal_type", event.detail, Object.assign({}, props, {
      car: car
    }));
  });
  useDMEventListener(DM_EVENT_DR_DEAL_TERMS_REFRESH, function (event) {
    setTimeout(function () {
      emitDMEvent(DM_EVENT_DR_DEAL_TERMS, terms);
    }, 500);
  });
  useDMEventListener(DM_EVENT_DR_UPDATE_TRADE, function (event) {
    var params = {
      trade_id: event.detail.trade_id,
      trade_estimate: event.detail.value || 0,
      trade_payoff: event.detail.payoff || 0
    };
    setTradeId(event.detail.trade_id);
    setTradeValue(event.detail.value || 0);
    setTradePayoff(event.detail.payoff || 0);
    if (!event.detail.onLoad) reCalc(params);
  });
  useDMEventListener(DM_EVENT_SOFT_CREDIT_RESULTS, function (event) {
    setCreditTier(event.detail.tier);
    setCreditScore(event.detail.high);
    if (!event.detail.onLoad) reCalc({
      credit_tier: event.detail.tier,
      credit_score: event.detail.high
    });
  });
  useDMEventListener("dm_trade_load", function (event) {
    var params = {
      trade_id: event.detail.trade_id,
      trade_estimate: event.detail.value || 0,
      trade_payoff: event.detail.payoff || 0
    };
    setTradeId(event.detail.trade_id);
    setTradeValue(event.detail.value || 0);
    setTradePayoff(event.detail.payoff || 0);
    if (!event.detail.onLoad) reCalc(params, {});
  });
  useDMEventListener(DM_EVENT_DR_PLANS_LOADED, function (event) {
    var planIds = [];
    allDealTypes.map(function (type) {
      if (deal.params[type] && deal.params[type].plans && deal.params[type].plans.length > 0) {
        deal.params[type].plans.map(function (p) {
          planIds.push(p.product_id);
        });
      }
    });
    event.detail.plans.map(function (p) {
      if (planIds.includes(p.product_id)) {
        p.selected = true;
      }
    });
    setPlans(event.detail.plans);
  });
  useDMEventListener("update_event", function (event) {
    var message = event.detail;
    if (message.type == "deal_update") {
      var params = {};
      var remoteParams = {};
      if (message.deal.down_payment) {
        params["dp"] = message.deal.down_payment;
        remoteParams[DR_CASH_DOWN] = parseInt(message.deal.down_payment);
      } else if (message.deal.type == "lease" && message.deal.term) {
        params["lease_term"] = message.deal.term;
        remoteParams[DR_LEASE_TERM] = parseInt(message.deal.term);
      } else if (message.deal.type == "lease" && message.deal.miles) {
        params["lease_miles"] = message.deal.miles;
        remoteParams[DR_LEASE_MILES] = parseInt(message.deal.miles);
      } else if (message.deal.type == "finance" && message.deal.term) {
        params["finance_term"] = message.deal.term;
        remoteParams[DR_FINANCE_TERM] = parseInt(message.deal.term);
      } else if (message.deal.credit_tier) {
        params["credit_tier"] = message.deal.credit_tier;
        setCreditTier(parseInt(message.deal.credit_tier));
        remoteParams[DR_CREDIT_TIER] = parseInt(message.deal.credit_tier);
      } else if (message.deal.offers) {
        var selected = [];
        var selectedIds = [];
        deal[message.deal.type].offers.map(function (ofr) {
          message.deal.offers.map(function (so) {
            ofr.selected = false;
            if (so.offer_id == ofr.offer_id || so.program_id == ofr.program_id) {
              ofr.selected = true;
              selected.push(ofr);
              selectedIds.push(ofr.offer_id);
              remoteParams[DR_OFFER + "_" + ofr.offer_id] = {
                prop_name: DR_OFFER,
                prop_id: "offer_id",
                id: ofr.offer_id,
                value: ofr
              };
            }
          });
        });
        params[message.deal.type + "_offers"] = selected;
      }
      reCalc(params, remoteParams);
    }
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      calcPayment();
    }
  }, []);
  React.useEffect(function () {
    if (zip != props.zip) {
      setZip(props.zip);
      reCalc({
        zip: props.zip
      }, {});
    }
  }, [props.zip]);
  var calcPayment = function calcPayment() {
    var config = ApiUtils.config;
    ApiUtils.postRequest("/v1/dr/quote", {
      dealer_id: config.internal_id,
      vin: car.vin,
      price: parseInt(car.price),
      type: dealType || 'all',
      credit_tier: creditTier,
      credit_score: parseInt(props.creditScore),
      zip: zip,
      quote_id: getQuoteId(),
      down: parseInt(props.down || 0),
      trade_estimate: parseInt(tradeValue),
      trade_payoff: parseInt(tradePayoff),
      vehicle: car
    }).then(function (data) {
      if (data) {
        var types = [];
        if (data.lease) {
          types.push({
            label: "Lease",
            dealType: 'lease'
          });
        }
        if (data.finance) {
          types.push({
            label: "Finance",
            dealType: 'finance'
          });
        }
        if (data.cash) {
          types.push({
            label: "Cash",
            dealType: 'cash'
          });
        }
        data.deal_types = types;
        var dType = types[0].dealType;
        data.deal_type = dType;
        data[dType];
        setDealType(dType);
        emitDMEvent(DM_EVENT_DR_DEAL_TYPE_SYNC, {
          dealType: dType
        });
        if (!data.trade) {
          data.trade = {};
        }
        if (!data.credit) {
          data.credit = {};
        }
        if (data.lease || data.finance || data.cash) setDeal(data);
        saveQuoteId(data);
        logEvent$1("dr", "load", "calc", {
          type: types[0].dealType,
          payment: data[types[0].dealType].payment,
          vin: car.vin
        }, props);
        loadAvailableTerms(data);
        loadAvailableOffers();
        emitDMEvent(DM_EVENT_DR_DEAL_LOADED, data);
        setTimeout(function () {
          var _data$finance, _data$lease, _data$finance2, _emitDMEvent;
          emitDMEvent(DM_EVENT_FIELD_VALUE_UPDATE, (_emitDMEvent = {}, _defineProperty__default["default"](_emitDMEvent, DR_CREDIT_TIER, data.credit_tier), _defineProperty__default["default"](_emitDMEvent, DR_CASH_DOWN, data.down), _defineProperty__default["default"](_emitDMEvent, DR_FINANCE_TERM, (_data$finance = data.finance) === null || _data$finance === void 0 ? void 0 : _data$finance.term), _defineProperty__default["default"](_emitDMEvent, DR_LEASE_TERM, (_data$lease = data.lease) === null || _data$lease === void 0 ? void 0 : _data$lease.term), _defineProperty__default["default"](_emitDMEvent, DR_LEASE_MILES, (_data$finance2 = data.finance) === null || _data$finance2 === void 0 ? void 0 : _data$finance2.mileage), _emitDMEvent));
        }, 200);
        if (props.onLoad) props.onLoad(data);
        if (props.deal) {
          var _data$trade;
          ApiUtils.postRequest("/v1/dr/deal", {
            deal_type: data.deal_type,
            quote_id: data.quote_id,
            trade_id: tradeId || ((_data$trade = data.trade) === null || _data$trade === void 0 ? void 0 : _data$trade.trade_id),
            vin: car.vin,
            vehicle: car
          }).then(function (data) {
            emitDMEvent(DM_EVENT_DR_DEAL_DETAILS_LOADED, data);
          });
        }
      }
    })["catch"](function (err) {});
  };
  var reCalc = React.useCallback(debounce__default["default"](function (newParams, remoteParams) {
    if (!deal || !deal.finance && !deal.lease) return;
    var reloadOffers = false;
    var config = ApiUtils.config;
    var params = {
      dealer_id: config.internal_id,
      vin: car.vin,
      price: parseInt(car.price),
      type: dealType || 'all',
      credit_tier: creditTier,
      zip: zip,
      down: parseInt(deal.down),
      vehicle: car
    };
    var plansSelected = [];
    if (newParams.plans) {
      newParams.plans.map(function (p) {
        plansSelected.push({
          product_id: p.product_id,
          name: p.name,
          category: p.category,
          price: p.price
        });
      });
    }
    if (deal['lease']) {
      params['lease'] = {};
      params['lease']['term'] = deal['lease']['term'];
      params['lease']['miles'] = deal['lease']['mileage'];
      params['lease']['offers'] = [];
      params['lease']['plans'] = plansSelected;
      var ofrList = newParams['lease_offers'] || (deal.params['lease'] ? deal.params['lease'].offers : []);
      ofrList.map(function (ofr) {
        params['lease']['offers'].push({
          offer_id: ofr.offer_id,
          amount: ofr.amount,
          category: ofr.category,
          program_id: ofr.program_id
        });
      });
    }
    if (deal['finance']) {
      params['finance'] = {};
      params['finance']['term'] = deal['finance']['term'];
      params['finance']['offers'] = [];
      params['finance']['plans'] = plansSelected;
      var _ofrList = newParams['finance_offers'] || (deal.params['finance'] ? deal.params['finance'].offers : []);
      _ofrList.map(function (ofr) {
        params['finance']['offers'].push({
          offer_id: ofr.offer_id,
          amount: ofr.amount,
          category: ofr.category,
          program_id: ofr.program_id
        });
      });
    }
    if (deal['cash']) {
      params['cash'] = {
        offers: []
      };
      params['cash']['plans'] = plansSelected;
      var _ofrList2 = newParams['cash_offers'] || (deal.params['cash'] ? deal.params['cash'].offers : []);
      _ofrList2.map(function (ofr) {
        params['cash']['offers'].push({
          offer_id: ofr.offer_id,
          amount: ofr.amount,
          category: ofr.category,
          program_id: ofr.program_id
        });
      });
    }
    if (newParams['lease_term']) {
      reloadOffers = true;
      params['lease']['term'] = parseInt(newParams['lease_term']);
    }
    if (newParams['lease_miles']) {
      reloadOffers = true;
      params['lease']['miles'] = parseInt(newParams['lease_miles']);
    }
    if (newParams['finance_term']) {
      reloadOffers = true;
      params['finance']['term'] = parseInt(newParams['finance_term']);
    }
    if (newParams['down_payment']) {
      params['down'] = parseInt(newParams['down_payment']);
    }
    if (newParams['credit_tier'] || newParams['credit_tier'] == 0) {
      reloadOffers = true;
      params['credit_tier'] = newParams['credit_tier'];
    }
    if (newParams['credit_score'] || newParams['credit_score'] == 0) {
      reloadOffers = true;
      params['credit_score'] = newParams['credit_score'];
    }
    if (tradeValue) {
      params['trade_estimate'] = parseInt(tradeValue);
    }
    if (tradePayoff) {
      params['trade_payoff'] = parseInt(tradePayoff);
    }
    Object.keys(newParams).map(function (k) {
      if (k != 'down_payment' && k != 'offers' && k != 'plans' && k != 'lease' && k != 'finance' && k != 'lease_term' && k != 'lease_miles' && k != 'finance_term' && k != 'lease_offers' && k != 'finance_offers' && k != 'cash_offers') {
        params[k] = newParams[k];
      }
    });
    ApiUtils.postRequest("/v1/dr/quote", params).then(function (data) {
      if (data) {
        var types = [];
        if (data.lease) {
          types.push({
            label: "Lease",
            dealType: 'lease'
          });
        }
        if (data.finance) {
          types.push({
            label: "Finance",
            dealType: 'finance'
          });
        }
        if (data.cash) {
          types.push({
            label: "Cash",
            dealType: 'cash'
          });
        }
        data.deal_types = types;
        var dealData = Object.assign(deal, data);
        dealData.deal_type = dealType;
        setDeal(dealData);
        if (!newParams.offer) loadOffers();
        emitDMEvent(DM_EVENT_DR_DEAL_LOADED, dealData);
        if (props.onLoad) props.onLoad(data);
        saveQuoteId(dealData);
        if (!remoteParams) {
          ApiUtils.postRequest("/v1/dr/deal", {
            deal_type: dealType,
            quote_id: data.quote_id,
            trade_id: newParams.trade_id || tradeId,
            vin: car.vin,
            vehicle: car
          }).then(function (data) {
            emitDMEvent(DM_EVENT_DR_DEAL_DETAILS_LOADED, data);
          });
        } else {
          emitDMEvent(DM_EVENT_FIELD_VALUE_UPDATE, remoteParams);
        }
        if (reloadOffers) loadAvailableOffers();
      }
    })["catch"](function (error) {
      emitDMEvent(DM_ERROR, JSON.parse(error));
    });
  }, 500), [deal]);
  var saveQuoteId = function saveQuoteId(deal) {
    saveQuoteIdForSession(car.vin, deal.quote_id);
  };
  var getQuoteId = function getQuoteId() {
    return getQuoteIdForSession(car.vin);
  };
  var loadAvailableTerms = function loadAvailableTerms(dealData) {
    ApiUtils.getRequest("/v1/dr/quote_options?quote_id=" + getQuoteId()).then(function (data) {
      if (data) {
        var cleanData = data;
        if (dealData && dealData.lease && data.lease) {
          if (data.lease.terms.indexOf(dealData.lease.term) < 0) {
            cleanData.lease.terms.push(dealData.lease.term);
            cleanData.lease.terms = cleanData.lease.terms.sort(function (a, b) {
              return a > b ? 1 : -1;
            });
          }
          if (data.lease.mileage.indexOf(dealData.lease.mileage) < 0) {
            cleanData.lease.mileage.push(dealData.lease.mileage);
            cleanData.lease.mileage = cleanData.lease.mileage.sort(function (a, b) {
              return a > b ? 1 : -1;
            });
          }
        }
        if (dealData && dealData.finance && data.finance && data.finance.terms.indexOf(dealData.finance.term) < 0) {
          cleanData.finance.terms.push(dealData.finance.term);
          cleanData.finance.terms = cleanData.finance.terms.sort(function (a, b) {
            return a > b ? 1 : -1;
          });
        }
        setTerms(cleanData);
        emitDMEvent(DM_EVENT_DR_DEAL_TERMS, cleanData);
      }
    });
  };
  var loadAvailableOffers = function loadAvailableOffers() {
    emitDMEvent(DM_EVENT_DR_OFFERS_DATA, offers);
  };
  var loadOffers = function loadOffers(deals) {
    // deals.offers.map((ofr) => {
    //   ofr.selected = offersSelected.indexOf(ofr.offer_id) >= 0
    // })
    // applyStackRules(deals.offers)
    // setOffers(deals.offers)
  };

  // Params change

  var onOfferToggle = function onOfferToggle(offers) {
    var params = {};
    Object.keys(offers).map(function (type) {
      params[type + "_offers"] = offers[type];
    });
    reCalc(params);
  };
  var onPlanToggle = function onPlanToggle(plan) {
    var val = plan.selected;
    logEvent$1("dr", "toggle", "plans", {
      type: dealType,
      new_value: val,
      vin: car.vin,
      id: car._id
    }, props);
    var selected = [];
    plans.map(function (p) {
      if (p.product_id == plan.product_id && plan.selected || p.product_id != plan.product_id && p.selected) {
        p.selected = true;
        selected.push({
          product_id: p.product_id,
          category: p.category,
          price: p.price,
          name: p.name
        });
      }
    });
    reCalc({
      plans: selected
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, props.children);
};

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMVisibilityTracker(props) {
  var _useState = React.useState(props.data || {}),
    _useState2 = _slicedToArray__default["default"](_useState, 1),
    data = _useState2[0];
  var _useState3 = React.useState({}),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    componentsVisible = _useState4[0],
    setComponentVisible = _useState4[1];
  var onVisiblityChange = function onVisiblityChange(name, value) {
    if (!componentsVisible[name] && value) {
      logEvent$1(props.page || ApiUtils.pageName || "vdp", "scroll", name, _objectSpread$8(_objectSpread$8({}, data), {}, {
        visible: true
      }), props);
    }
    if (value) {
      var values = Object.assign({}, componentsVisible);
      values[name] = 1;
      setComponentVisible(values);
    }
    if (props.onChange) props.onChange(value);
  };
  return /*#__PURE__*/React__default["default"].createElement(VisibilitySensor__default["default"], {
    onChange: function onChange(isVisible) {
      return onVisiblityChange(props.section || props.name, isVisible);
    },
    partialVisibility: true,
    minTopValue: props.minTopValue || 64
  }, props.children);
}

function DMDealForm(props) {
  var _useState = React.useState({}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useDMEventListener(DM_EVENT_DR_DEAL_PARAM_INPUT, function (event) {
    var name = event.detail.name.replace("dr_", "");
    var start = !form[name];
    var data = {};
    data[name] = event.detail.value;
    setForm(data);
    if (event.detail.name == DR_CREDIT_TIER && event.detail.options) {
      var creditScore = 820;
      event.detail.options.map(function (e) {
        if (e.id == parseInt(event.detail.value)) creditScore = e.low;
      });
      data["credit_score"] = creditScore;
    }
    emitDMEvent(DM_EVENT_DR_DEAL_PARAM_CHANGE, data);
    if (start) {
      logEvent$1("dr", "edit", name, data, props);
    }
  });
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "payment"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "dr_deal_terms",
    name: "DR Deal Terms",
    action: "/v1/dr/quote"
  }, props.children));
}

function DMOffersForm(props) {
  var _useState = React.useState({}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    offers = _useState2[0],
    setOffers = _useState2[1];
  useDMEventListener(DM_EVENT_DR_OFFER_CHANGE, function (event) {
    var allOffers = getAllOffers(offers);
    var offer = allOffers.filter(function (e) {
      return e.offer_id == event.detail.value.offer_id;
    })[0];
    offer.selected = !offer.selected;
    // const offer = event.detail.value
    var current = applyStackRules(offer);
    var selected = {
      lease: [],
      finance: [],
      cash: []
    };
    Object.keys(selected).map(function (type) {
      Object.keys(offers[type]).map(function (k) {
        Object.keys(offers[type][k]).map(function (cat) {
          offers[type][k][cat].map(function (ofr) {
            var o = current.filter(function (e) {
              return e.offer_id == ofr.offer_id;
            })[0];
            if (o.selected) {
              ofr.selected = true;
              selected[type].push(ofr);
            }
          });
        });
      });
    });
    emitDMEvent(DM_EVENT_DR_OFFER_TOGGLE, selected);
    logEvent$1("dr", offer.selected ? 'added' : 'removed', "offer", {
      id: offer.id,
      amount: offer.amount,
      name: offer.name,
      category: offer.category
    }, props);
  });
  useDMEventListener(DM_EVENT_DR_OFFERS_DATA, function (event) {
    if (event.detail) {
      syncOffersSelection(offers, event.detail);
      setOffers(event.detail);
    } else {
      loadAvailableOffers();
    }
  });
  React.useEffect(function () {
    if (vin() && getQuoteIdForSession(vin())) {
      loadAvailableOffers();
    } else {
      emitDMEvent(DM_EVENT_DR_OFFERS_SYNC);
    }
  }, []);
  var vin = function vin() {
    return props.vin || ApiUtils.config.vin;
  };
  var loadAvailableOffers = function loadAvailableOffers() {
    ApiUtils.getRequest("/v1/dr/offers?quote_id=" + getQuoteIdForSession(vin())).then(function (data) {
      syncOffersSelection(offers, data);
      setOffers(data);
      emitDMEvent(DM_EVENT_DR_OFFERS_LOADED, data);
      if (props.onLoad) props.onLoad(data);
    });
  };
  var syncOffersSelection = function syncOffersSelection(src, dest) {
    var srcList = getAllOffers(src);
    var destList = getAllOffers(dest);
    srcList.map(function (ofr) {
      var curr = destList.filter(function (e) {
        return e.offer_id == ofr.offer_id;
      });
      if (curr) {
        ofr.selected = curr.selected;
        ofr.disabled = curr.disabled;
      }
    });
  };
  var applyStackRules = function applyStackRules(offer) {
    var origOffers = Object.assign({}, offers);
    var current = getAllOffers(origOffers);
    var matching = current.filter(function (e) {
      return e.offer_id == offer.offer_id;
    });
    matching.map(function (ofr) {
      ofr.selected = offer.selected;
    });
    var stacked = current.filter(function (e) {
      return offer.exclusion.includes(e.program_id);
    });
    stacked.map(function (ofr) {
      ofr.selected = false;
      ofr.disabled = true;
    });
    var exclusions = [];
    current.map(function (ofr) {
      if (ofr.selected) {
        ofr.exclusion.map(function (p) {
          exclusions.push(p);
        });
      }
    });
    current.map(function (ofr) {
      if (exclusions.includes(ofr.program_id)) {
        ofr.selected = false;
        ofr.disabled = true;
      } else {
        ofr.disabled = false;
      }
    });
    var ofr = current.filter(function (e) {
      return e.offer_id == offer.offer_id;
    });
    ofr.selected = offer.selected;
    ofr.disabled = false;
    setOffers(origOffers);
    return current;
  };
  var getAllOffers = function getAllOffers(data) {
    return [].concat(_toConsumableArray__default["default"](data.lease && data.lease.consumer && data.lease.consumer.cash ? data.lease.consumer.cash : []), _toConsumableArray__default["default"](data.lease && data.lease.consumer && data.lease.consumer.specials ? data.lease.consumer.specials : []), _toConsumableArray__default["default"](data.lease && data.lease.dealer && data.lease.dealer.cash ? data.lease.dealer.cash : []), _toConsumableArray__default["default"](data.lease && data.lease.dealer && data.lease.dealer.specials ? data.lease.dealer.specials : []), _toConsumableArray__default["default"](data.finance && data.finance.consumer && data.finance.consumer.cash ? data.finance.consumer.cash : []), _toConsumableArray__default["default"](data.finance && data.finance.consumer && data.finance.consumer.specials ? data.finance.consumer.specials : []), _toConsumableArray__default["default"](data.finance && data.finance.dealer && data.finance.dealer.cash ? data.finance.dealer.cash : []), _toConsumableArray__default["default"](data.finance && data.finance.dealer && data.finance.dealer.specials ? data.finance.dealer.specials : []), _toConsumableArray__default["default"](data.cash && data.cash.consumer && data.cash.consumer.cash ? data.cash.consumer.cash : []), _toConsumableArray__default["default"](data.cash && data.cash.consumer && data.cash.consumer.specials ? data.cash.consumer.specials : []), _toConsumableArray__default["default"](data.cash && data.cash.dealer && data.cash.dealer.cash ? data.cash.dealer.cash : []), _toConsumableArray__default["default"](data.cash && data.cash.dealer && data.cash.dealer.specials ? data.cash.dealer.specials : []));
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "offers"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "dr_offers",
    name: "DR Offers"
  }, props.children));
}

function DMPlansForm(props) {
  var _useState = React.useState([]),
    _useState2 = _slicedToArray__default["default"](_useState, 2);
    _useState2[0];
    var setProducts = _useState2[1];
  var _useState3 = React.useState([]),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    plans = _useState4[0],
    setPlans = _useState4[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    if (props.vin || props.quote_id) {
      setupPlans();
    }
  });
  useDMEventListener(DM_EVENT_DR_PLAN_CHANGE, function (event) {
    var plan = event.detail.value;
    plans.map(function (p) {
      if (p.category == plan.category && p.product_id != plan.product_id) {
        emitDMEvent(DM_EVENT_DR_PLAN_SYNC, {
          product_id: p.product_id
        });
      }
    });
    emitDMEvent(DM_EVENT_DR_PLAN_TOGGLE, plan);
    logEvent$1("dr", plan.selected ? 'added' : 'removed', "plan", {
      id: plan.id,
      price: plan.price,
      name: plan.title || plan.name,
      category: plan.category
    }, props);
  });
  React.useEffect(function () {
    if (ApiUtils.config && (props.vin || props.quote_id)) {
      setupPlans();
    }
  }, []);
  var setupPlans = function setupPlans() {
    ApiUtils.getRequest("/v1/plans/configuration", {}).then(function (data) {
      if (data) {
        setProducts(data.products);
        if (data.products.length == 0) {
          loadPlans({
            type: props.dealType,
            vin: props.vin,
            term: props.term,
            rate: props.apr,
            quote_id: props.quote_id
          }, true);
        } else {
          var productsLoaded = 0;
          data.products.map(function (p, index) {
            loadPlans({
              type: props.dealType,
              vin: props.vin,
              term: props.term,
              rate: props.apr,
              quote_id: props.quote_id,
              product_id: p.product_id
            }).then(function (availablePlans) {
              productsLoaded += 1;
              if (productsLoaded == data.products.length) {
                emitDMEvent(DM_EVENT_DR_PLANS_LOADED, {
                  plans: availablePlans
                });
              }
            });
          });
        }
      }
    });
  };
  var loadPlans = function loadPlans(params, triggerEvent) {
    return new Promise(function (resolve) {
      ApiUtils.getRequest("/v1/plans", params).then(function (data) {
        if (data) {
          logEvent$1("dr", "load", "plans", params, props);
          var allPlans = plans;
          data.plans.map(function (p) {
            allPlans.push(p);
          });
          setPlans(allPlans);
          if (triggerEvent) emitDMEvent(DM_EVENT_DR_PLANS_LOADED, {
            plans: allPlans
          });
          resolve(allPlans);
        }
      });
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "plans"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "dr_plans",
    name: "DR Protection Plans"
  }, props.children));
}

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DMTradeForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = React.useState(props.vehType || 'vin'),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  var _useState3 = React.useState(props.data || {}),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    form = _useState4[0],
    setForm = _useState4[1];
  var _useState5 = React.useState({}),
    _useState6 = _slicedToArray__default["default"](_useState5, 2),
    config = _useState6[0],
    setConfig = _useState6[1];
  var _useState7 = React.useState('trim'),
    _useState8 = _slicedToArray__default["default"](_useState7, 2),
    step = _useState8[0],
    setStep = _useState8[1];
  var _useState9 = React.useState(),
    _useState10 = _slicedToArray__default["default"](_useState9, 2),
    vehicle = _useState10[0],
    setVehicle = _useState10[1];
  var _useState11 = React.useState(),
    _useState12 = _slicedToArray__default["default"](_useState11, 2),
    estimate = _useState12[0],
    setEstimate = _useState12[1];
  var formRef = React.useRef();
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_TRADE_VEHICLE_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
    if (event.detail.name == TRADE_VEHICLE_ID_TYPE) {
      setType(event.detail.value || 'vin');
    }
  });
  useDMEventListener(DM_EVENT_TRADE_CONFIG_REFRESH, function (event) {
    var _config$meta;
    emitDMEvent(DM_EVENT_FIELD_OPTIONS + "_" + TRADE_VEHICLE_CONDITION, {
      options: (_config$meta = config.meta) === null || _config$meta === void 0 ? void 0 : _config$meta.condition
    });
  });
  useDMEventListener(DM_EVENT_TRADE_APPLY_DEAL, function (event) {
    if (estimate.value) {
      applyToDeal(estimate);
    }
  });
  useDMEventListener(DM_EVENT_TRADE_REMOVE_DEAL, function (event) {
    emitDMEvent(DM_EVENT_DR_UPDATE_TRADE, {});
    if (estimate) {
      setEstimate(Object.assign(estimate, {
        status: 1
      }));
      emitDMEvent(DM_EVENT_TRADE_ESTIMATE, estimate);
      updateTrade({
        status: 1
      });
    }
  });
  useDMEventListener(DM_EVENT_TRADE_FORM_SUBMIT, function (event) {
    // formRef.current.submit()
    onVehicleSubmit();
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var applyToDeal = function applyToDeal(estimate) {
    if (estimate.value) {
      emitDMEvent(DM_EVENT_DR_UPDATE_TRADE, {
        trade_id: estimate.trade_id,
        value: estimate.value,
        payoff: estimate.payoff
      });
      setEstimate(Object.assign(estimate, {
        status: 2
      }));
      emitDMEvent(DM_EVENT_TRADE_ESTIMATE, estimate);
      updateTrade({
        status: 2
      });
    }
  };
  var setup = function setup() {
    var dmConfig = ApiUtils.config;
    ApiUtils.getRequest("/v1/trade/configuration", {
      dealer_id: dmConfig.internal_id
    }).then(function (data) {
      if (data) {
        var _data$meta;
        setConfig(Object.assign(data, props.steps ? {
          steps: props.steps
        } : {}));
        emitDMEvent(DM_EVENT_CONFIG, {
          trade: _objectSpread$7(_objectSpread$7({}, data.settings), {}, {
            steps: data.steps,
            meta: data.meta
          })
        });
        emitDMEvent(DM_EVENT_FIELD_OPTIONS + "_" + TRADE_VEHICLE_CONDITION, {
          options: (_data$meta = data.meta) === null || _data$meta === void 0 ? void 0 : _data$meta.condition
        });
        if (data.settings && data.settings.iframed) {
          if (data.settings.message) {
            window.addEventListener("message", function (message) {
              if (message && message.data && message.origin.indexOf(data.settings.domain) > -1) {
                var params = message.data;
                if (typeof message.data == 'string') {
                  params = JSON.parse(message.data);
                }
                var match = false;
                data.settings.message.map(function (p) {
                  if (params[p.key] == p.value) {
                    match = true;
                  }
                });
                if (match) {
                  getEstimate(null, params);
                }
              }
            });
          }
        }
        if (props.display || !(data.settings && data.settings.iframed)) {
          ApiUtils.getRequest("/v1/trade/current").then(function (data) {
            if (data && data.value) {
              setEstimate(data);
              data.onLoad = true;
              emitDMEvent(DM_EVENT_TRADE_ESTIMATE, data);
              emitDMEvent("dm_trade_load", data);
              if (props.onFormSubmit) {
                props.onFormSubmit({
                  event: DM_EVENT_TRADE_ESTIMATE,
                  estimate: data,
                  current: true
                });
              }
            }
          });
        }
      }
    });
  };
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("trv_", "");
    var start = !form[name];
    var data = _objectSpread$7({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("trade", "edit", name, {}, props);
    }
  };
  var onVehicleSubmit = function onVehicleSubmit(e) {
    if (e) e.preventDefault();
    var dmConfig = ApiUtils.config;
    var formEl = e ? e.nativeEvent.target : formRef.current;
    logFormSubmitEvent(formEl);
    if (step != 'trim' && config.steps && config.steps.indexOf(step) + 1 == config.steps.length) {
      getEstimate();
    } else if (step != 'trim') {
      var nextStep = config.steps[config.steps.indexOf(step) + 1];
      setStep(nextStep);
      emitDMEvent(DM_EVENT_TRADE_VEHICLE_UPDATE, Object.assign(vehicle, {
        step: nextStep,
        isLastStep: config.steps.indexOf(nextStep) == config.steps.length - 1
      }));
      if (props.onFormSubmit) {
        props.onFormSubmit({
          event: DM_EVENT_TRADE_VEHICLE_UPDATE,
          vehicle: vehicle
        });
      }
    } else if (step == 'trim') {
      if (type == 'plate') {
        if (form.vehicle_plate && form.vehicle_state) {
          ApiUtils.postRequest("/v1/trade/decode_vehicle", {
            type: 'plate',
            plate: form.vehicle_plate,
            state: form.vehicle_state,
            dealer_id: dmConfig.internal_id
          }).then(function (data) {
            if (data) {
              setupVinData(data);
              logEvent$1("trade", "edit", "vehicle", {}, props);
            }
          });
        }
      } else if (type == 'vin') {
        if (form.vehicle_vin) {
          ApiUtils.postRequest("/v1/trade/decode_vehicle", {
            vin: form.vehicle_vin,
            dealer_id: config.internal_id
          }).then(function (data) {
            if (data) {
              setupVinData(data);
            }
          });
        }
      } else if (type == 'ymmt') {
        ApiUtils.postRequest("/v1/trade/decode_vehicle", {
          year: form.vehicle_year,
          make: form.vehicle_make,
          model: form.vehicle_model,
          trim: form.vehicle_trim,
          dealer_id: dmConfig.internal_id
        }).then(function (data) {
          if (data) {
            setTrims(data.trims);
            if (data.trims.length == 1) {
              setTrim(data.trims[0]);
              if (data.trims[0].options.length > 0) setView('options');
              if (data.trims[0].options.length == 0) setView('miles');
            }
          }
        });
      }
    }
  };
  var setupVinData = function setupVinData(data) {
    var vehicle = {
      trims: data.trims,
      step: 'trim'
    };
    vehicle.vehicle = data.trims[0];
    vehicle.step = config.steps[1];
    setVehicle(vehicle);
    setStep(vehicle.step);
    emitDMEvent(DM_EVENT_TRADE_VEHICLE_UPDATE, vehicle);
    if (!vehicle.step && form.vehicle_miles) {
      getEstimate(null, {
        vehicle: vehicle
      });
    } else {
      if (props.onFormSubmit) {
        props.onFormSubmit({
          event: DM_EVENT_TRADE_VEHICLE_UPDATE,
          vehicle: vehicle
        });
      }
    }
  };
  var getEstimate = function getEstimate(event, params) {
    var errors = [];
    if (!form.vehicle_miles) {
      errors.push({
        field: TRADE_VEHICLE_MILES,
        message: "Mileage is required."
      });
    }
    if (!form.vehicle_condition) {
      errors.push({
        field: TRADE_VEHICLE_CONDITION,
        message: "Condition is required."
      });
    }
    if (!form.vehicle_zip) {
      errors.push({
        field: TRADE_VEHICLE_ZIP,
        message: "Zip is required."
      });
    }
    if (errors.length > 0) {
      emitDMEvent(DM_FORM_ERROR, {
        form: "trade",
        errors: errors
      });
      return;
    }
    var selectedVehicle = (params === null || params === void 0 ? void 0 : params.vehicle) || vehicle;
    var dmConfig = ApiUtils.config;
    var payload = Object.assign({}, params || {}, {
      dealer_id: dmConfig.internal_id,
      vehicle: selectedVehicle ? Object.assign(selectedVehicle.vehicle, {
        vin: form.vehicle_vin
      }) : {},
      miles: form.vehicle_miles,
      vin: form.vehicle_vin,
      payoff: form.vehicle_payoff,
      vehicle_id: selectedVehicle ? selectedVehicle.vehicle_id : null,
      condition: form.vehicle_condition,
      zip: form.vehicle_zip || dmConfig.zip,
      vid: useVisitorId(),
      sid: useVisitorSessionId()
    });
    ApiUtils.postRequest("/v1/trade/estimate", payload).then(function (data) {
      if (data) {
        setEstimate(data);
        emitDMEvent(DM_EVENT_TRADE_ESTIMATE, data);
        if (props.onFormSubmit) {
          props.onFormSubmit({
            event: DM_EVENT_TRADE_ESTIMATE,
            estimate: data,
            editMode: false
          });
        }
      }
    });
  };
  var updateTrade = function updateTrade(params) {
    ApiUtils.postRequest("/v1/trade/" + estimate.trade_id, params, 'PUT').then(function (data) {
      if (data) {
        if (props.autoApply) {
          applyToDeal(estimate);
        }
        setEstimate(data);
        emitDMEvent(DM_EVENT_TRADE_ESTIMATE, data);
      }
    });
  };
  var remove = function remove() {
    ApiUtils.postRequest("/v1/trade/" + estimate.trade_id, {
      status: -1
    }, 'PUT').then(function (data) {
      setup();
    });
  };
  React.useImperativeHandle(ref, function () {
    return {
      remove: remove,
      getEstimate: getEstimate
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "trade_form"
  }), config.settings && config.settings.iframed && !props.display ? /*#__PURE__*/React__default["default"].createElement("iframe", {
    src: config.settings.url,
    width: "100%",
    height: "100%",
    className: (props.className || ' ') + " dm-trade-iframe"
  }) : /*#__PURE__*/React__default["default"].createElement("form", {
    ref: formRef,
    className: props.className || '',
    id: props.id || "trade_form",
    name: props.name || "Trade Form",
    onSubmit: function onSubmit(e) {
      return onVehicleSubmit(e);
    }
  }, props.children));
});
DMTradeForm.displayName = "DMTRadeForm";
function submitTradeForm(event) {
  if (event) event.preventDefault();
  emitDMEvent(DM_EVENT_TRADE_FORM_SUBMIT);
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMSoftCreditForm(props) {
  var _useState = React.useState(props.data || {}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = React.useState(),
    _useState4 = _slicedToArray__default["default"](_useState3, 2);
    _useState4[0];
    var setApplication = _useState4[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_SOFT_CREDIT_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {
    ApiUtils.getRequest("/v1/credit/current").then(function (data) {
      if (data && data.tier) {
        data.onLoad = true;
        publishApp(data);
      }
    });
  };
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("scf_", "");
    var start = !form[name];
    var data = _objectSpread$6({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("soft_credit", "edit", name, {}, props);
    }
  };
  var publishApp = function publishApp(app) {
    setApplication(app);
    emitDMEvent(DM_EVENT_SOFT_CREDIT_RESULTS, app);
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    var config = ApiUtils.config;
    var formEl = e.nativeEvent.target;
    logFormSubmitEvent(formEl);
    form.dealer_id = config.internal_id;
    form.vid = useVisitorId();
    form.sid = useVisitorSessionId();
    ApiUtils.postRequest("/v1/credit/check", form).then(function (data) {
      if (data) {
        publishApp(data);
        if (data.async) {
          setTimeout(function () {
            pollResults(data, 0);
          }, 4000);
        }
      }
    });
  };
  var pollResults = function pollResults(app, retryCount) {
    var config = ApiUtils.config;
    ApiUtils.getRequest("/v1/credit/poll_soft_credit?dealer_id=" + config.internal_id + "&attempt=" + retryCount, app).then(function (data) {
      if (data) {
        if (data.status == 500) {
          if (retryCount < 5) {
            setTimeout(function () {
              pollResults(app, retryCount + 1);
            }, 4000);
          }
        } else {
          if (data['high']) {
            publishApp(data);
          } else {
            if (retryCount < 5) {
              setTimeout(function () {
                pollResults(app, retryCount + 1);
              }, 4000);
            }
          }
        }
      }
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "soft_credit_form"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "soft_credit_form",
    name: "Soft Credit Form",
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
}

var _requiredFields;
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var requiredFields$1 = (_requiredFields = {}, _defineProperty__default["default"](_requiredFields, CREDIT_APP_FIRST_NAME, "First name is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_LAST_NAME, "Last name is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_ADDRESS, "Street address is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_EMAIL, "Your email is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_PHONE, "A phone number is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_CITY, "City is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_STATE, "State is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_ZIP, "Zip code is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_DOB, "Date of birth is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_SSN, "Social Security Number is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_HOUSING_STATUS, "Housing status is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_MORTGAGE_RENT, "Type of housing payment is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_TIME_AT_ADDR_YEARS, "Years at the current address is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_TIME_AT_ADDR_MONTHS, "Months at the current address is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_INCOME_TYPE, "Type of incomes is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_INCOME_INTERVAL, "Interval of income is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_INCOME, "Income is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_EMPLOYMENT_STATUS, "Employment status is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_EMPLOYER, "Name of employer is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_JOB_TITLE, "Job title is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_WORK_PHONE, "Work phone number is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_TIME_AT_JOB_YEARS, "Years at job is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_TIME_AT_JOB_MONTHS, "Months at job is required."), _defineProperty__default["default"](_requiredFields, CREDIT_APP_HAVE_CO_APP, "Please specify if you have a co-applicant or not."), _requiredFields);

// const requiredCoAppFields = {
//   [CREDIT_APP_CO_APP_FIRST_NAME]: "First name is required.",
//   [CREDIT_APP_CO_APP_LAST_NAME]: "Last name is required.",
//   [CREDIT_APP_CO_APP_ADDRESS]: "Street address is required.",
//   [CREDIT_APP_CO_APP_CITY]: "City is required.",
//   [CREDIT_APP_CO_APP_STATE]: "State is required.",
//   [CREDIT_APP_CO_APP_ZIP]: "Zip code is required.",
//   [CREDIT_APP_CO_APP_DOB]: "Date of birth is required.",
//   [CREDIT_APP_CO_APP_SSN]: "Social Security Number is required.",
//   [CREDIT_APP_CO_APP_HOUSING_STATUS]: "Housing status is required.",
//   [CREDIT_APP_CO_APP_MORTGAGE_RENT]: "Type of housing payment is required.",
//   [CREDIT_APP_CO_APP_TIME_AT_ADDR_YEARS]: "Years at the current address is required.",
//   [CREDIT_APP_CO_APP_TIME_AT_ADDR_MONTHS]: "Months at the current address is required.",
//   [CREDIT_APP_CO_APP_INCOME_TYPE]: "Type of incomes is required.",
//   [CREDIT_APP_CO_APP_INCOME_INTERVAL]: "Interval of income is required.",
//   [CREDIT_APP_CO_APP_INCOME]: "Income is required.",
//   [CREDIT_APP_CO_APP_EMPLOYMENT_STATUS]: "Employment status is required.",
//   [CREDIT_APP_CO_APP_EMPLOYER]: "Name of employer is required.",
//   [CREDIT_APP_CO_APP_JOB_TITLE]: "Job title is required.",
//   [CREDIT_APP_CO_APP_WORK_PHONE]: "Work phone number is required.",
//   [CREDIT_APP_CO_APP_TIME_AT_JOB_YEARS]: "Years at job is required.",
//   [CREDIT_APP_CO_APP_TIME_AT_JOB_MONTHS]: "Months at job is required.",
// }

var payloadDef = {
  "first_name": CREDIT_APP_FIRST_NAME,
  "middle_name": CREDIT_APP_MIDDLE_NAME,
  "last_name": CREDIT_APP_LAST_NAME,
  "suffix": CREDIT_APP_SUFFIX,
  "email": CREDIT_APP_EMAIL,
  "home_phone": CREDIT_APP_PHONE,
  "mobile_phone": CREDIT_APP_MOBILE_PHONE,
  "address_1": CREDIT_APP_ADDRESS,
  "address_2": CREDIT_APP_ADDRESS_2,
  "city": CREDIT_APP_CITY,
  "state": CREDIT_APP_STATE,
  "zip": CREDIT_APP_ZIP,
  "curr_address_less_2y": CREDIT_APP_ADDR_LESS_2Y,
  "previous_address": {
    "address": CREDIT_APP_PREV_ADDR_ADDRESS,
    "city": CREDIT_APP_PREV_ADDR_CITY,
    "state": CREDIT_APP_PREV_ADDR_STATE,
    "zip": CREDIT_APP_PREV_ADDR_ZIP
  },
  "ssn": CREDIT_APP_SSN,
  "dob": CREDIT_APP_DOB,
  "housing": {
    "status": CREDIT_APP_HOUSING_STATUS,
    "mortgage_rent": CREDIT_APP_MORTGAGE_RENT,
    "time_at_address": {
      "years": CREDIT_APP_TIME_AT_ADDR_YEARS,
      "months": CREDIT_APP_TIME_AT_ADDR_MONTHS
    }
  },
  "income": {
    "type": CREDIT_APP_INCOME_TYPE,
    "interval": CREDIT_APP_INCOME_INTERVAL,
    "income": CREDIT_APP_INCOME
  },
  "other_income": {
    "type": CREDIT_APP_OTHER_INCOME_TYPE,
    "interval": CREDIT_APP_OTHER_INCOME_INTERVAL,
    "income": CREDIT_APP_OTHER_INCOME,
    "source": CREDIT_APP_OTHER_INCOME_SOURCE
  },
  "employment": {
    "status": CREDIT_APP_EMPLOYMENT_STATUS,
    "employer": CREDIT_APP_EMPLOYER,
    "job_title": CREDIT_APP_JOB_TITLE,
    "work_phone": CREDIT_APP_WORK_PHONE,
    "time_at_job": {
      "years": CREDIT_APP_TIME_AT_JOB_YEARS,
      "months": CREDIT_APP_TIME_AT_JOB_MONTHS
    }
  },
  "previous_employment": {
    "status": CREDIT_APP_PREV_EMPLOYMENT_STATUS,
    "employer": CREDIT_APP_PREV_EMPLOYER,
    "job_title": CREDIT_APP_PREV_JOB_TITLE,
    "work_phone": CREDIT_APP_PREV_WORK_PHONE,
    "time_at_job": {
      "years": CREDIT_APP_PREV_TIME_AT_JOB_YEARS,
      "months": CREDIT_APP_PREV_TIME_AT_JOB_MONTHS
    }
  }
};
function DMCreditAppForm(props) {
  var _useState = React.useState(props.data || {}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = React.useState(),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    deal = _useState4[0],
    setDeal = _useState4[1];
  var _useState5 = React.useState(false),
    _useState6 = _slicedToArray__default["default"](_useState5, 2),
    inReview = _useState6[0];
    _useState6[1];
  var _useState7 = React.useState(1),
    _useState8 = _slicedToArray__default["default"](_useState7, 2),
    salt = _useState8[0],
    setSalt = _useState8[1];
  var formRef = React.useRef();
  useDMEventListener(DM_EVENT_DR_DEAL_DETAILS_LOADED, function (event) {
    setDeal(event.detail);
  });
  useDMEventListener(DM_EVENT_CREDIT_APP_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  useDMEventListener(DM_EVENT_CREDIT_APP_SUBMIT, function (event) {
    _onSubmit(event.detail.event);
  });
  useDMEventListener("demo_credit_app_form", function (event) {
    setForm(event.detail);
    setSalt(new Date().getTime());
  });
  React.useEffect(function () {
    emitDMEvent(DM_EVENT_DR_DEAL_REQUEST);
  }, []);
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("ca_", "");
    var start = !form[fieldName];
    var data = _objectSpread$5({}, form);
    data[fieldName] = value;
    setForm(data);
    if (start) {
      logEvent$1("credit_app", "edit", name, {}, props);
    }
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    var formEl = formRef.current;
    logFormSubmitEvent(formEl);
    var errors = [];
    Object.keys(requiredFields$1).map(function (k) {
      if (!form[k] && form[k] != 0) {
        errors.push({
          field: k,
          message: requiredFields$1[k]
        });
      }
    });
    var payload = {
      deal_id: deal === null || deal === void 0 ? void 0 : deal.deal_id,
      vin: deal.vehicle.vin,
      applicant: buildPayload({}, payloadDef),
      co_applicant: buildPayload({}, payloadDef, true)
    };
    ApiUtils.postRequest("/v1/credit/application", payload).then(function (data) {
      if (data && data.application_id) {
        if (props.onSubmit) props.onSubmit(data);
      }
    });
    // emitDMEvent(DM_EVENT_CREDIT_APP_RESULTS, { form: "credit-app", errors: errors, data: form })
    if (!inReview) return;
  };
  var buildPayload = function buildPayload(data, props, coApp) {
    Object.keys(props).map(function (k) {
      if (_typeof__default["default"](props[k]) == 'object') {
        data[k] = buildPayload({}, props[k]);
      } else {
        var keyName = coApp ? props[k].replace("ca_", "ca_co_app_") : props[k];
        data[k] = form[keyName];
      }
    });
    return data;
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "credit_app_form"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    key: salt,
    ref: formRef,
    className: props.className || '',
    id: "credit_app_form",
    name: "Credit Application",
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
}
function submitCreditAppForm(event) {
  if (event) event.preventDefault();
  emitDMEvent(DM_EVENT_CREDIT_APP_SUBMIT, {
    event: event
  });
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var DMSchedulingForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var formRef = React.useRef();
  var _useState = React.useState(),
    _useState2 = _slicedToArray__default["default"](_useState, 2);
    _useState2[0];
    var setConfig = _useState2[1];
  var _useState3 = React.useState({
      customer: {}
    }),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    form = _useState4[0],
    setForm = _useState4[1];
  var _useState5 = React.useState({}),
    _useState6 = _slicedToArray__default["default"](_useState5, 2),
    options = _useState6[0],
    setOptions = _useState6[1];
  var _useState7 = React.useState([]),
    _useState8 = _slicedToArray__default["default"](_useState7, 2),
    optionsSelected = _useState8[0],
    setOptionsSelected = _useState8[1];
  var _useState9 = React.useState([]),
    _useState10 = _slicedToArray__default["default"](_useState9, 2),
    availableTimes = _useState10[0],
    setAvailableTimes = _useState10[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_APPOINTMENT_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  useDMEventListener(DM_EVENT_CONTACT_INPUT, function (event) {
    setContactFormAttribute(event.detail.name, event.detail.value);
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {
    var dmConfig = ApiUtils.config;
    ApiUtils.getRequest("/v1/scheduling/configuration", {
      dealer_id: dmConfig.internal_id
    }).then(function (data) {
      setConfig(data);
    });
  };
  var loadOptions = function loadOptions(vin, year, make, model) {
    var dmConfig = ApiUtils.config;
    ApiUtils.getRequest("/v1/scheduling/options", {
      dealer_id: dmConfig.internal_id,
      vin: vin || form.vin,
      year: year || form.year,
      make_name: make || form.make_name,
      model_name: model || form.model_name
    }).then(function (data) {
      setOptions(data.options);
      if (props.onOptionsLoad) {
        props.onOptionsLoad(data.options);
      }
    });
  };
  var loadAvailableTimes = function loadAvailableTimes(date) {
    var dmConfig = ApiUtils.config;
    ApiUtils.getRequest("/v1/scheduling/times", {
      dealer_id: dmConfig.internal_id,
      vin: form.vin,
      year: form.year,
      make_name: form.make_name,
      model_name: form.model_name,
      date: (date || form.appointment_date).toISOString(),
      options: optionsSelected
    }).then(function (data) {
      setAvailableTimes(data.available);
      if (props.onScheduleLoad) {
        props.onScheduleLoad(data.available);
      }
    });
  };
  var setContactFormAttribute = function setContactFormAttribute(fieldName, value) {
    var name = fieldName.replace("c_", "");
    var start = !form.customer[name];
    var data = _objectSpread$4({}, form);
    data.customer[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("scheduling", "edit", name, {}, props);
    }
  };
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("appo_", "");
    var start = !form[name];
    var data = _objectSpread$4({}, form);
    data[name] = value;
    setForm(data);
    if (name == "vehicle_vin" && value.length == 17) {
      loadOptions(value);
    }
    if (name == "vehicle_year" || name == "vehicle_make" || name == "vehicle_model") {
      if (name == "vehicle_year" && form.vehicle_make && form.vehicle_model) loadOptions(null, value);
      if (name == "vehicle_make" && form.vehicle_year && form.vehicle_model) loadOptions(null, null, value);
      if (name == "vehicle_model" && form.vehicle_year && form.vehicle_make) loadOptions(null, null, null, value);
    }
    if (name == "appointment_date") {
      loadAvailableTimes(new Date(value));
    }
    if (start) {
      logEvent$1("scheduling", "edit", name, {}, props);
    }
  };
  var setSelectedOptions = function setSelectedOptions(selected) {
    setOptionsSelected(selected);
  };
  var getOptions = function getOptions() {
    return options;
  };
  var getAvailability = function getAvailability() {
    return availableTimes;
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    var dateTime = new Date(Date.parse(form.appointment_date + ' ' + form.appointment_time)).toISOString();
    var payload = {
      date_time: dateTime,
      customer: form.customer,
      vin: form.vehicle_vin,
      year: form.vehicle_year,
      make_name: form.make_name,
      model_name: form.model_name,
      options: optionsSelected
    };
    ApiUtils.postRequest("/v1/scheduling", payload).then(function (data) {
      if (props.onSubmit) {
        props.onSubmit(data);
      }
    });
  };
  React.useImperativeHandle(ref, function () {
    return {
      setSelectedOptions: setSelectedOptions,
      getOptions: getOptions,
      getAvailability: getAvailability
    };
  });
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "scheduling_form"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    ref: formRef,
    className: props.className || '',
    id: props.id || "scheduling_form",
    name: props.name || "Scheduling Form",
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
});
DMSchedulingForm.displayName = "DMSchedulingForm";

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMScheduleTestDriveForm(props) {
  var _useState = React.useState(props.data || {}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_CONTACT_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  useDMEventListener(DM_EVENT_APPOINTMENT_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {};
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("scf_", "").replace("appo_", "");
    var start = !form[name];
    var data = _objectSpread$3({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("schedule_test_drive", "edit", name, {}, props);
    }
  };
  var _onSubmit = function onSubmit(e) {};
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "schedule_test_drive"
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "schedule_test_drive_form",
    name: "Schedule Test Drive From",
    onSubmit: function onSubmit(e) {
      return _onSubmit();
    }
  }, props.children));
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMMessagingForm(props) {
  var _useState = React.useState({}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_MESSAGING_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {};
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("scf_", "");
    var start = !form[name];
    var data = _objectSpread$2({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("soft_credit", "edit", name, {}, props);
    }
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    if (!form[MESSAGING_BODY]) return;
    var config = ApiUtils.config;
    var formEl = e.nativeEvent.target;
    logFormSubmitEvent(formEl);
    var payload = {};
    payload.dealer_id = config.internal_id;
    payload.vid = useVisitorId();
    payload.sid = useVisitorSessionId();
    payload.body = form[MESSAGING_BODY];
    payload.src_url = window.location.href;
    ApiUtils.postRequest("/v1/chats/send_message", payload).then(function (data) {});
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "messaging" + (props.section ? "_" + section : "")
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "messaging" + (props.section ? "_" + section : "") + "_form",
    name: "Messaging Form",
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
}

function DMDocumentForm(props) {
  var _useState = React.useState(props.type),
    _useState2 = _slicedToArray__default["default"](_useState, 1),
    type = _useState2[0];
  var _useState3 = React.useState(),
    _useState4 = _slicedToArray__default["default"](_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  useDMEventListener(DM_EVENT_FILE_SELECT, function (event) {
    if (event.detail.type == type) {
      setFile(file);
    }
  });
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    // const config = ApiUtils.config
    // const formEl = e.nativeEvent.target
    // logFormSubmitEvent(formEl)
    // form.dealer_id = config.internal_id
    // form.vid = useVisitorId()
    // form.sid = useVisitorSessionId()
    // ApiUtils.postRequest("/v1/credit/check", form)
    // .then((data) => {
    //   if (data) {
    //     publishApp(data)
    //     if (data.async) {
    //       setTimeout(() => {
    //         pollResults(data, 0)
    //       }, 4000)
    //     }
    //   }
    // })
  };

  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: "document_" + type
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: "document_form_" + type,
    name: "Document Form - " + type,
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMAppointmentForm(props) {
  var _useState = React.useState(props.data || {
      type: props.type
    }),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var _useState3 = React.useState("appointment_form" + (props.type ? "_" + props.type : "")),
    _useState4 = _slicedToArray__default["default"](_useState3, 1),
    formId = _useState4[0];
  var formRef = React.useRef();
  useDMEventListener(DM_EVENT_APPOINTMENT_INPUT, function (event) {
    if (event.target.form_id == formId) {
      setFormAttribute(event.detail.name, event.detail.value);
    }
  });
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("appo_", "");
    var start = !form[name];
    var data = _objectSpread$1({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent("appointment_form", "edit", name, {
        type: props.type
      }, props);
    }
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    var formEl = formRef.current;
    logFormSubmitEvent(formEl);
    var errors = [];
    Object.keys(requiredFields).map(function (k) {
      if (!form[k] && form[k] != 0) {
        errors.push({
          field: k,
          message: requiredFields[k]
        });
      }
    });
    emitDMEvent(DM_EVENT_APPOINTMENT_RESULTS, {
      form: "credit-app",
      errors: errors,
      data: form
    });
    if (!inReview) return;
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: formId
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    ref: formRef,
    className: props.className || '',
    id: formId,
    name: "Appointment" + (props.type ? " - " + props.type : ""),
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.type && /*#__PURE__*/React__default["default"].createElement("input", {
    type: "hidden",
    name: "type",
    value: props.type
  }), props.children));
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function DMForm(props) {
  var _useState = React.useState(props.data || {}),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  useDMEventListener(DM_EVENT_SOFT_CREDIT_INPUT, function (event) {
    setFormAttribute(event.detail.name, event.detail.value);
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {};
  var setFormAttribute = function setFormAttribute(fieldName, value) {
    var name = fieldName.replace("scf_", "");
    var start = !form[name];
    var data = _objectSpread({}, form);
    data[name] = value;
    setForm(data);
    if (start) {
      logEvent$1("soft_credit", "edit", name, {}, props);
    }
  };
  var _onSubmit = function onSubmit(e) {
    e.preventDefault();
    var formEl = e.nativeEvent.target;
    logFormSubmitEvent(formEl);
    props.onSubmit(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
    section: props.id
  }), /*#__PURE__*/React__default["default"].createElement("form", {
    className: props.className || '',
    id: props.id,
    name: props.name,
    onSubmit: function onSubmit(e) {
      return _onSubmit(e);
    }
  }, props.children));
}

var DMVehicleHistory = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = React.useState(),
    _useState2 = _slicedToArray__default["default"](_useState, 2),
    details = _useState2[0],
    setDetails = _useState2[1];
  useDMEventListener(DM_EVENT_CONFIG_LOADED, function (event) {
    setup();
  });
  React.useEffect(function () {
    if (ApiUtils.config) {
      setup();
    }
  }, []);
  var setup = function setup() {
    ApiUtils.getRequest("/v1/vehicles/icr_details?vin=" + props.vin).then(function (data) {
      setDetails(data);
      if (props.onLoad) {
        props.onLoad(data);
      }
    });
  };
  var getDetails = function getDetails() {
    return details;
  };
  React.useImperativeHandle(ref, function () {
    return {
      getDetails: getDetails
    };
  });
  if (details && details.report_url) {
    return /*#__PURE__*/React__default["default"].createElement(DMVisibilityTracker, _extends__default["default"]({}, props, {
      section: "vhr_section"
    }), props.children);
  } else {
    return props.children;
  }
});
DMVehicleHistory.displayName = "DMVehicleHistory";

var returnLibrary = function returnLibrary() {
  return {
    DMProvider: DMProvider,
    DMField: DMField,
    DM_FIELDS: DMFields,
    DMTrade: DMTrade,
    DMDRProvider: DMDRProvider,
    DMDealForm: DMDealForm,
    DMOffersForm: DMOffersForm,
    DMPlansForm: DMPlansForm,
    DMTradeForm: DMTradeForm,
    DMSoftCreditForm: DMSoftCreditForm,
    DMMessagingForm: DMMessagingForm,
    DMCreditAppForm: DMCreditAppForm,
    DMScheduleTestDriveForm: DMScheduleTestDriveForm,
    DMSchedulingForm: DMSchedulingForm,
    DMDocumentForm: DMDocumentForm,
    DMAppointmentForm: DMAppointmentForm,
    DMForm: DMForm,
    DMVisibilityTracker: DMVisibilityTracker,
    DMVehicleHistory: DMVehicleHistory,
    DM_ERROR: DM_ERROR,
    DM_FORM_ERROR: DM_FORM_ERROR,
    DM_EVENT_CONFIG: DM_EVENT_CONFIG,
    DM_EVENT_DR_DEAL_LOADED: DM_EVENT_DR_DEAL_LOADED,
    DM_EVENT_DR_OFFERS_LOADED: DM_EVENT_DR_OFFERS_LOADED,
    DM_EVENT_DR_PLANS_LOADED: DM_EVENT_DR_PLANS_LOADED,
    DM_EVENT_TRADE_VEHICLE_UPDATE: DM_EVENT_TRADE_VEHICLE_UPDATE,
    DM_EVENT_CREDIT_APP_SUBMIT: DM_EVENT_CREDIT_APP_SUBMIT,
    DM_EVENT_VISITOR_IDS: DM_EVENT_VISITOR_IDS,
    DM_TRADE_STEP_MILES: DM_TRADE_STEP_MILES,
    DM_TRADE_STEP_OPTIONS: DM_TRADE_STEP_OPTIONS,
    DM_EVENT_TRADE_ESTIMATE: DM_EVENT_TRADE_ESTIMATE,
    DM_EVENT_SOFT_CREDIT_RESULTS: DM_EVENT_SOFT_CREDIT_RESULTS,
    DM_EVENT_CREDIT_APP_RESULTS: DM_EVENT_CREDIT_APP_RESULTS,
    logDMEvent: logDMEvent,
    onDMDealTypeChange: onDMDealTypeChange,
    onDMTradeVehicleSubmit: onDMTradeVehicleSubmit,
    useDMEventListener: useDMEventListener,
    emitDMEvent: emitDMEvent,
    submitTradeForm: submitTradeForm,
    submitCreditAppForm: submitCreditAppForm
  };
};
var index = returnLibrary();

module.exports = index;
